import { pageMessages } from './pageMessages';

export type LocaleCode = 'id' | 'en';

const messagesId = {
    'lang.id': 'ID',
    'lang.en': 'EN',
    'lang.idFull': 'Bahasa Indonesia',
    'lang.enFull': 'English',

    'common.menu': 'Menu',
    'common.home': 'Beranda',
    'common.back': 'Kembali',
    'common.next': 'Lanjut',
    'common.backHint': 'Halaman sebelumnya',
    'common.nextHint': 'Halaman berikutnya (setelah Kembali)',
    'common.close': 'Tutup',
    'common.reset': 'Reset',
    'common.save': 'Simpan',
    'common.cancel': 'Batal',
    'common.done': 'Selesai',
    'common.pickDate': 'Pilih tanggal',
    'common.all': 'Semua',
    'common.detail': 'Detail',
    'common.loading': 'Memuat…',
    'common.retry': 'Coba lagi',
    'common.search': 'Cari',

    'auth.logout': 'Keluar',
    'auth.username': 'Nama pengguna',
    'auth.password': 'Kata sandi',
    'auth.remember': 'Tetap masuk di perangkat ini',
    'auth.signIn': 'Masuk',
    'auth.badCredentials': 'Nama pengguna atau kata sandi tidak cocok',
    'auth.tagline': 'Satu ruang kerja untuk jurnal, laporan, bank, dan pajak — rapi dari hari pertama.',
    'auth.brandEyebrow': 'Keuangan modern · Siap audit',
    'auth.headline': 'Rapi di buku. Jelas di laporan. Yakin saat memutuskan.',
    'auth.formLead': 'Masuk ke akun Anda untuk melanjutkan.',
    'auth.point1': 'Laporan & buku besar terhubung tanpa spreadsheet berantakan',
    'auth.point2': 'Bank, rekonsiliasi, dan pajak dalam satu alur kerja',
    'auth.point3': 'Dasbor eksekutif yang menunjuk aksi hari ini',
    'auth.tasyaTap': 'Sapa Tasya',
    'auth.tasyaTapHint': 'Ketuk / tab Tasya untuk tip + suara · senyap setelah selesai',
    'auth.tasyaIntroHint': 'Suara {n}/{total} · lalu senyap otomatis',
    'auth.tasyaMutedHint': 'Senyap · ketuk Tasya untuk dengar tip lain',
    'auth.tasyaCountdown': 'Mulai dalam {n}',
    'auth.tasyaCountdownHint': 'Menyiapkan 5 tip acak…',
    'auth.tasyaCountdownLabel': 'Mulai',
    'auth.tasyaTapToHear': 'Ketuk Tasya supaya suaraku terdengar',
    'auth.tasyaTapToHearHint': 'Ketuk / tab kartu Tasya — 5 tip berbunyi, lalu senyap',
    'auth.tasyaEnableSound': 'Aktifkan suara Tasya',
    'auth.tasyaEnableHint': 'Browser memblokir autoplay — tekan tombol di bawah',
    'auth.tasyaBlockedMsg': 'Suara masih diblokir. Tekan lagi “Aktifkan suara Tasya”.',
    'auth.tasyaErrorMsg': 'Gagal memutar suara. Coba tekan tombol lagi.',
    'auth.tasyaOnline': 'Online',
    'auth.tasyaVoiceOn': 'Suara nyala',
    'auth.tasyaVoiceOff': 'Suara mati',
    'auth.tasyaLine1':
      'Hai, aku Tasya. Selamat datang di Jasa Pembayaran. Yuk masuk dengan tenang, aku dampingi.',
    'auth.tasyaLine2':
      'Satu ketuk masuk, lalu dasbor menyambutmu dengan ringkasan yang jernih dan siap ditindak.',
    'auth.tasyaLine3':
      'Kas, bank, dan arus dana bisa kamu pantau cepat tanpa bolak-balik spreadsheet.',
    'auth.tasyaLine4':
      'Piutang dan utang lebih jinak kalau dicek rutin. Aku bantu jaga ritme hariannya.',
    'auth.tasyaLine5':
      'Mutasi bank pintar mencocokkan rekening dengan jurnal, biar saldo tidak “misterius”.',
    'auth.tasyaLine6':
      'Pajak, setoran, dan tenggat bisa dilacak di sini. Tepat waktu, pikiran lebih lega.',
    'auth.tasyaLine7':
      'Laporan disusun siap audit dan siap putusan. Bukan hanya cantik, tapi bisa dipercaya.',
    'auth.tasyaLine8':
      'Centang tetap masuk di perangkat ini supaya sesi berikutnya langsung nyaman.',
    'auth.tasyaLine9':
      'Bingung pilih menu? Ketuk aku. Aku kasih arah yang sederhana, tanpa drama.',
    'auth.tasyaLine10':
      'Beberapa badan usaha bisa dikelola rapi dalam satu ruang kerja yang sama.',
    'auth.tasyaLine11':
      'Rekonsiliasi bukan momok. Kita pecah pelan-pelan sampai angka benar-benar cocok.',
    'auth.tasyaLine12':
      'Absensi dan kasbon ikut terhubung, supaya operasional dan keuangan tidak terpisah.',
    'auth.tasyaLine13':
      'Hari padat? Mulai dari antrian aksi di dasbor. Selesaikan yang penting dulu.',
    'auth.tasyaLine14':
      'Neraca dan laba rugi bisa ditelusuri sampai buku besar. Transparansi sampai akar.',
    'auth.tasyaLine15':
      'Ada selisih? Jangan panik. Kita lacak bareng sampai sumbernya ketemu.',
    'auth.tasyaLine16':
      'Jurnal rapi hari ini menyelamatkan audit esok. Kebiasaan kecil, dampak besar.',
    'auth.tasyaLine17':
      'Keamanan dijaga: koneksi aman, data terenkripsi, sesimu tetap nyaman.',
    'auth.tasyaLine18':
      'Dari kas kecil sampai pajak besar, alurnya bisa tetap ringan dan teratur.',
    'auth.tasyaLine19':
      'Keputusan bagus lahir dari data bersih. Yuk kita rapikan angka bareng-bareng.',
    'auth.tasyaLine20':
      'Aku di sini biar kamu tidak sendirian menghadapi angka yang ramai.',
    'auth.tasyaLine21':
      'Saldo bank yang selaras membuat malam lebih tenang. Cocokkan, lalu istirahat.',
    'auth.tasyaLine22':
      'Keuangan modern itu sederhana: rapi, cepat, dan siap dipakai untuk putusan.',
    'auth.tasyaLine23':
      'Tip kecil hari ini bisa menghemat berjam-jam kerja minggu depan. Yuk konsisten.',
    'auth.tasyaLine24':
      'Yang rumit kita sederhanakan. Yang penting kita utamakan. Sisanya menyusul.',
    'auth.tasyaLine25':
      'Buku bersih bukan impian. Itu kebiasaan yang bisa kamu bangun pelan-pelan.',
    'auth.tasyaLine26':
      'Pajak, bank, dan laporan bisa sejalan tanpa drama file bertebaran.',
    'auth.tasyaLine27':
      'Kalau lelah, istirahat sebentar. Angka menunggu dengan sabar. Aku juga.',
    'auth.tasyaLine28':
      'Tim keuangan hebat punya ritme harian. Aku bantu kamu jaga ritme itu.',
    'auth.tasyaLine29':
      'Siap keputusan yang lebih yakin? Masuk sekarang, biarkan data yang bicara.',
    'auth.tasyaLine30':
      'Terima kasih sudah di sini. Mari buat keuanganmu terasa lebih ringan hari ini.',
    'auth.sessionCountdown': 'Sesi: {time} Menit ke logout',
    'auth.sessionShort': 'Sesi {time}',
    'auth.idleExpired': 'Sesi berakhir karena tidak ada aktivitas 24 jam. Silakan login ulang.',
    'auth.sessionHint': 'Sesi berakhir otomatis setelah 24 jam tidak aktif.',
    'auth.secureNote': 'Terenkripsi end-to-end',
    'auth.panelBadge': 'Sesi aman',
    'auth.systemStatus': 'Operasional normal',
    'auth.usernamePh': 'Nama pengguna',
    'auth.passwordPh': 'Kata sandi',
    'auth.showPassword': 'Tampilkan kata sandi',
    'auth.hidePassword': 'Sembunyikan kata sandi',

    'device.label': 'Mode perangkat',
    'device.desktop': 'Desktop',
    'device.tablet': 'Tablet',
    'device.hp': 'HP',
    'device.desktopHint': 'Lebar penuh layar',
    'device.tabletHint': 'Preview 768px',
    'device.hpHint': 'Preview 390px',
    'device.fullWidth': 'Full',
    'device.previewHint': 'Preview layout',
    'profile.myProfile': 'Profil Saya',
    'profile.myAccount': 'Akun Saya',
    'profile.myTask': 'Tugas Saya',
    'profile.langLabel': 'Bahasa',
    'profile.privacyHint': 'Sembunyikan nominal sensitif di layar',
    'profile.salary': 'Gaji',
    'profile.commission': 'Komisi',
    'profile.payLabel': 'Gaji dan komisi',
    'profile.payDemo': 'Contoh',
    'profile.position': 'Jabatan',
    'profile.positionDemo': 'Staff (contoh)',
    'profile.joinedAt': 'Masuk kerja',
    'profile.lastAttendance': 'Absen terakhir',
    'profile.secWork': 'Info kerja',
    'profile.secSession': 'Sesi aktif',
    'profile.sessionOn': 'Aktif',
    'profile.sessionWarn': 'Segera logout',
    'profile.secPrefs': 'Preferensi',
    'profile.secMenu': 'Menu akun',
    'profile.menuPeek': 'Pengaturan',
    'profile.expandAll': 'Buka semua',
    'profile.collapseAll': 'Tutup semua',
    'profile.fillTitle': 'Akses terlindungi',
    'profile.fillHint': 'Sesi aktif · data akun aman',
    'theme.label': 'Tampilan',
    'theme.light': 'Terang',
    'theme.dark': 'Gelap',
    'switch.localeTitle': 'Mengganti bahasa',
    'switch.localeToId': 'Beralih ke Bahasa Indonesia…',
    'switch.localeToEn': 'Switching to English…',
    'switch.localeSub': 'Menyesuaikan seluruh antarmuka',
    'switch.localeStepUi': 'Memuat teks antarmuka…',
    'switch.localeStepLogin': 'Menyelaraskan halaman masuk…',
    'switch.localeStepApp': 'Menerapkan ke seluruh aplikasi…',
    'switch.authChipLocale': 'Bahasa',
    'switch.authChipTheme': 'Tema',
    'switch.authChipSession': 'Sesi',
    'switch.themeTitle': 'Mengganti tampilan',
    'switch.themeToLight': 'Mode terang',
    'switch.themeToDark': 'Mode gelap',
    'switch.themeSub': 'Menerapkan warna & kontras',
    'switch.pageTitle': 'Memuat halaman',
    'switch.pageTo': 'Menuju',
    'switch.pageSub': 'Mohon tunggu sebentar…',
    'switch.bootTitle': 'Menyiapkan aplikasi',
    'switch.bootSub': 'Memuat sesi & antarmuka…',
    'switch.authTitle': 'Sedang masuk',
    'switch.authSub': 'Menyiapkan ruang kerja Anda…',
    'switch.authStepLocale': 'Memuat bahasa antarmuka…',
    'switch.authStepTheme': 'Menerapkan tema & warna…',
    'switch.authStepAuth': 'Memverifikasi akun…',
    'switch.authStepDash': 'Membuka dasbor…',
    'privacy.hideAll': 'Sembunyikan semua angka',
    'privacy.showAll': 'Tampilkan semua angka',

    'quality.readyReview': 'Siap review konsultan',
    'quality.needComplete': 'Perlu lengkapi data',
    'quality.notReadySpt': 'Belum siap SPT',

    'notif.tooltip': 'Kotak masuk operasional — rekonsiliasi & kelengkapan',
    'notif.kicker': 'Kotak masuk operasional',
    'notif.title': 'Notifikasi',
    'notif.alertCount': '{n} peringatan',
    'notif.reload': 'Muat ulang',
    'notif.matched': 'Terekonciliasi',
    'notif.pendingMatch': 'Menunggu cocok',
    'notif.dataScore': 'Skor data',
    'notif.recon': 'Rekonsiliasi',
    'notif.task': 'Tugas',
    'notif.count': 'Jumlah',
    'notif.reconSafe': 'Rekonsiliasi aman — tidak ada tugas',
    'notif.reconSafeShort': 'Rekonsiliasi aman',
    'notif.reconWaiting': '{n} tugas rekonsiliasi menunggu',
    'notif.quality': 'Kelengkapan',
    'notif.alert': 'Peringatan',
    'notif.qualitySafe': 'Data lengkap — tidak ada peringatan',
    'notif.highRisk': 'Risiko tinggi',
    'notif.highRiskDetail': 'Perlu tinjauan manual sebelum dicocokkan',
    'notif.medRisk': 'Risiko sedang',
    'notif.medRiskDetail': 'Cek arah / tanggal / nominal',
    'notif.lowRisk': 'Siap cocok otomatis',
    'notif.lowRiskDetail': 'Risiko rendah — bisa cocok massal',
    'notif.aging': 'Menua > 30 hari',
    'notif.agingDetail': 'Statement belum dicocokkan lama',
    'notif.dup': 'Grup duplikat',
    'notif.dupDetail': 'Bandingkan di studio perbandingan',
    'notif.group': 'Kandidat 1↔N / N↔1',
    'notif.groupDetail': 'Pencocokan grup tersedia',
    'notif.pendingTasks': 'Tugas menunggu',
    'notif.pendingDetail': 'Pasangan saran siap ditinjau',
    'notif.taskList': 'Daftar tugas',
    'notif.taskAmount': '{amount}',
    'notif.npwpEmpty': 'NPWP kosong',
    'notif.critical': 'Temuan kritis',
    'notif.criticalDetail': 'Perlu ditinjau di kelengkapan data',
    'notif.gap': 'Celah statement',
    'notif.gapDetail': 'Bulan tanpa e-statement',
    'notif.scoreLabel': 'Skor data {score}',
    'notif.openRecon': 'Buka Rekonsiliasi',
    'notif.openQuality': 'Buka Kelengkapan',
    'notif.fillNpwp': 'Lengkapi NPWP',
    'notif.checkQuality': 'Cek kelengkapan data',
    'notif.qualityOk': 'Data identitas & kelengkapan baik',
    'notif.hr': 'HR / Kasbon',
    'notif.hrOk': 'Tidak ada tugas HR / kasbon',
    'notif.hrIncomplete': '{n} karyawan aktif data belum lengkap ({pct}%)',
    'notif.hrIncompleteDetail': 'Lengkapi NIK/NPWP karyawan aktif (resign diabaikan)',
    'notif.hrMissingNpwp': '{n} karyawan aktif tanpa NPWP',
    'notif.hrMissingNpwpDetail': 'Isi NPWP di master karyawan aktif',
    'notif.hrMissingNik': '{n} karyawan aktif tanpa NIK',
    'notif.hrMissingNikDetail': 'Isi NIK di master karyawan aktif',
    'notif.kasbonPending': 'Kasbon menunggu approve',
    'notif.kasbonPendingDetail': 'Buka Karyawan & Gaji untuk Setujui / Tolak',
    'notif.aiConsDetail': 'AI sudah eksekusi — silakan cross-check',
    'notif.markReviewed': 'Sudah dicek',
    'notif.markAllReviewed': 'Centang semua AI',
    'notif.openLink': 'Buka',
    'notif.tax': 'Batas setor pajak',
    'notif.taxOverdue': 'Pajak terlambat',
    'notif.taxH3': 'Pajak H-3',
    'notif.taxH7': 'Pajak H-7',

    'nav.section.main': 'Utama',
    'nav.section.journal': 'Buku Jurnal',
    'nav.section.cashImport': 'Kas & Impor',
    'nav.section.trx': 'Transaksi',
    'nav.section.master': 'Master Data',
    'nav.section.cash': 'Kas & Bank',
    'nav.section.report': 'Laporan',
    'nav.section.classify': 'Klasifikasi & Analisis',
    'nav.section.tax': 'Pajak',
    'nav.section.customer': 'Customer',
    'nav.section.control': 'Kontrol',
    'nav.dashboard': 'Dashboard',
    'nav.calendar': 'Kalender',
    'nav.activities': 'Aktifitas',
    'nav.reminders': 'Reminder',
    'nav.periodClose': 'Tutup Periode',
    'nav.closeChecklist': 'Checklist Tutup',
    'nav.quickJournal': 'Jurnal Cepat',
    'nav.multiJournal': 'Buat Jurnal',
    'nav.journals': 'Jurnal',
    'nav.journalsHub': 'Hub Jurnal',
    'nav.generalJournal': 'Jurnal',
    'nav.closeWizard': 'Tutup Bulan',
    'nav.lookupRef': 'Cari Ref ID',
    'nav.correction': 'Pembetulan',
    'nav.openingBalance': 'Saldo Awal',
    'nav.importGroup': 'Impor & Statement',
    'nav.statements': 'E-Statement Pintar',
    'nav.import': 'Impor Data',
    'nav.accounts': 'Daftar Akun',
    'nav.employees': 'Karyawan & Gaji',
    'nav.attendance': 'Absensi Karyawan',
    'nav.payslips': 'Slip Gaji',
    'nav.hrPortal': 'Portal Saya',
    'nav.reconciliation': 'Rekonsiliasi',
    'nav.reconPendingTip': '{n} mutasi pending di antrian rekonsiliasi',
    'nav.pendingCount': '{n} pending',
    'nav.cashBank': 'Posisi Kas/Bank',
    'nav.updateRekening': 'Rekening Bank',
    'nav.cashFlow': 'Arus Kas',
    'nav.cashForecast': 'Prakiraan Kas',
    'nav.reportsHub': 'Pusat Laporan',
    'nav.downloadReports': 'Download Laporan',
    'nav.coreReports': 'Laporan Inti',
    'nav.financialStatements': 'Laporan Keuangan',
    'nav.comparative': 'Perbandingan YoY',
    'nav.bankReport': 'Per Bank/Rekening',
    'nav.intercompany': 'Antar Perusahaan',
    'nav.budget': 'Anggaran vs Aktual',
    'nav.ledger': 'Buku Besar',
    'nav.trialBalance': 'Neraca Saldo',
    'nav.incomeStatement': 'Laba Rugi',
    'nav.balanceSheet': 'Neraca',
    'nav.omsetYearly': 'Omset Tahunan',
    'nav.assets': 'Laporan Aset',
    'nav.liabilities': 'Liabilitas',
    'nav.equity': 'Ekuitas',
    'nav.revenue': 'Pendapatan',
    'nav.expense': 'Beban',
    'nav.ar': 'Piutang Usaha',
    'nav.ap': 'Utang Usaha',
    'nav.depreciation': 'Penyusutan',
    'nav.inventory': 'Persediaan',
    'nav.cogs': 'HPP',
    'nav.accrual': 'Akrual vs Kas',
    'nav.companies': 'Perusahaan & NPWP',
    'nav.clients': 'Klien / WP',
    'nav.engagements': 'Engagement & Fee',
    'nav.invoices': 'Invoice & Proforma',
    'nav.vendorBills': 'Tagihan Vendor',
    'nav.fixedAssets': 'Aset Tetap',
    'nav.recurringJournals': 'Jurnal Berulang',
    'nav.journalApprovals': 'Approval Jurnal',
    'nav.dimensions': 'Dimensi',
    'nav.marketing': 'Marketing & WA',
    'nav.whatsapp': 'WhatsApp',
    'nav.kurs': 'Kalkulator Kurs',
    'nav.products': 'Produk',
    'nav.taxHub': 'Pusat Pajak',
    'nav.taxHubHome': 'PPh Final 0,5%',
    'nav.taxCalendar': 'Kalender Pajak',
    'nav.taxVat': 'Rekap PPN',
    'nav.taxPph21': 'Kalkulator PPh 21',
    'nav.sptMasa': 'Paket SPT Masa',
    'nav.withholdings': 'PPh 23 / Bukti Potong',
    'nav.ssp': 'SSP / e-Bupot',
    'nav.fiscal': 'Koreksi Fiskal',
    'nav.taxDocuments': 'Surat & Berkas',
    'nav.taxRequests': 'Request Pajak',
    'nav.taxRequestsMe': 'Request Saya',
    'nav.customerPortal': 'Portal Customer',
    'nav.customers': 'Kelola Customer',
    'nav.consolidated': 'Konsolidasi JGI+JGT',
    'nav.unearned': 'Uang Muka / DP',
    'nav.quality': 'Kelengkapan Data',
    'nav.audit': 'Jejak Audit',
    'nav.backup': 'Backup & Restore',
    'nav.users': 'User & Akses',
    'nav.tasya': 'Tasya Livechat',

    'fav.title': 'Favorit',
    'fav.emptyEdit': 'Tekan ikon pin di menu di bawah untuk menambah',
    'fav.empty': 'Belum ada favorit — tekan pin untuk mulai',
    'fav.save': 'Simpan',
    'fav.cancel': 'Batal',
    'fav.dirtyHint': 'Ada perubahan — tekan pin lalu Simpan',
    'fav.manage': 'Kelola pin favorit',
    'fav.done': 'Selesai kelola pin',
    'fav.pin': 'Pin ke Favorit',
    'fav.unpin': 'Lepas pin',

    'dash.overview': 'Ringkasan eksekutif',
    'dash.title': 'Dasbor keuangan',
    'dash.heroSub': 'Kas, piutang–utang, pajak, dan aksi hari ini — siap diputuskan.',
    'dash.heroFocus': 'Fokus kerja',
    'dash.heroPillCash': 'Kas & bank',
    'dash.heroPillAr': 'Piutang',
    'dash.heroPillTax': 'Pajak',
    'dash.heroPillAction': 'Aksi hari ini',
    'dash.activePeriod': 'Periode aktif',
    'dash.filterPt': 'Filter PT',
    'dash.allPt': 'Semua PT',
    'dash.period': 'Periode',
    'dash.from': 'Dari',
    'dash.to': 'Sampai',
    'dash.filterBar': 'Filter dashboard',
    'dash.quickPeriods': 'Periode',
    'dash.applyFilters': 'Terapkan',
    'dash.refreshData': 'Muat ulang',
    'dash.applyHint': 'Filter sudah otomatis — klik untuk muat ulang data',
    'dash.filtersApplied': 'Data dimuat ulang',
    'dash.activeFilters': 'Filter aktif',
    'dash.comparePrev': 'Bandingkan vs {from} → {to}',
    'dash.comparePrevShort': 'Bandingkan',
    'dash.filterMore': 'Filter lanjutan',
    'dash.filterLess': 'Sembunyikan lanjutan',
    'dash.ptQuick': 'Perusahaan',
    'dash.clearPt': 'Semua PT',
    'dash.chipCustom': 'Kustom',
    'dash.chipMonthShort': 'Bulan',
    'dash.chip30Short': '30h',
    'dash.chipYearShort': '{year}',
    'dash.monthsAgoShort1': '1 bln lalu',
    'dash.monthsAgoShortN': '{n} bln lalu',
    'dash.gapTitle': 'Celah & kelengkapan data',
    'dash.gapHint': 'Ringkasan celah statement, temuan audit, dan identitas pajak yang perlu dilengkapi sebelum tutup buku / SPT.',
    'dash.gapScore': 'Skor',
    'dash.gapStatement': 'celah statement',
    'dash.criticalFindings': 'temuan kritis',
    'dash.reconPending': 'rekonsiliasi tertunda',
    'dash.metricGaps': 'Celah statement',
    'dash.metricCritical': 'Temuan kritis',
    'dash.metricRecon': 'Rekonsiliasi',
    'dash.metricGapsShort': 'celah',
    'dash.metricCriticalShort': 'kritis',
    'dash.metricReconShort': 'rekonsiliasi',
    'dash.npwpEmpty': 'NPWP kosong',
    'dash.completeness': 'Kelengkapan',
    'dash.closeChecklist': 'Checklist Tutup',
    'dash.shortcuts': 'Pintasan',
    'dash.quickActions': 'Aksi Cepat',
    'dash.quickHint': 'Menu operasional yang sering dipakai — buka langsung tanpa lewat sidebar.',
    'dash.qaEdit': 'Edit pintasan',
    'dash.qaDone': 'Selesai edit',
    'dash.qaAdd': 'Tambah',
    'dash.qaRemove': 'Hapus pintasan',
    'dash.qaReset': 'Reset default',
    'dash.qaManageTitle': 'Atur pintasan',
    'dash.qaManageHint': 'Edit & tambah menu favorit di grid bawah',
    'dash.qaEditingTitle': 'Mode edit aktif',
    'dash.qaEditingHint': 'Hapus item, atau tekan Tambah untuk menambah pintasan',
    'dash.qaPickTitle': 'Pilih pintasan',
    'dash.qaPickSub': '{n} / {max} dipilih — ketuk untuk menambah atau melepas',
    'dash.qaSearch': 'Cari menu atau halaman…',
    'dash.qaEmptySearch': 'Tidak ada menu yang cocok',
    'dash.menus': 'menu',
    'dash.kpiKicker': 'Indikator',
    'dash.kpiTitle': 'Ringkasan periode',
    'dash.fxKicker': 'Showcase · Grafik keuangan',
    'dash.fxTitle': 'Arus kas, penjualan & laba/rugi',
    'dash.fxSub': 'Ketuk Buka untuk melihat arus kas, penjualan & laba/rugi periode filter.',
    'dash.fxSubOpen': 'Tiga kartu visual dari data periode — contoh otomatis jika seri kosong.',
    'dash.fxSubShort': 'Ketuk Buka untuk lihat grafik periode ini.',
    'dash.fxSubOpenShort': 'Tiga kartu visual dari data periode aktif.',
    'dash.fxRefresh': 'Muat ulang',
    'dash.fxOpen': 'Buka',
    'dash.fxClose': 'Tutup',
    'dash.fxApply': 'Terapkan',
    'dash.fxExpand': 'Perbesar grafik',
    'dash.fxSyncDash': 'Sync dari dashboard',
    'dash.fxSearchPt': 'Cari PT',
    'dash.fxDemo': 'Contoh data',
    'dash.fxCashTitle': 'Arus Kas',
    'dash.fxCashIn': 'Kas Masuk',
    'dash.fxCashOut': 'Kas Keluar',
    'dash.fxCashNet': 'Kas Bersih',
    'dash.fxOpenCash': 'Buka laporan arus kas',
    'dash.reconRecentTitle': 'Rekonsiliasi terakhir',
    'dash.reconLastUpdate': 'Terakhir update',
    'dash.reconRecentEmpty': 'Belum ada aktivitas rekonsiliasi',
    'dash.reconOpenDesk': 'Buka meja rekonsiliasi',
    'dash.reconNew': 'Baru',
    'dash.reconJustNow': 'baru saja',
    'dash.reconMinsAgo': '{n} mnt lalu',
    'dash.reconHoursAgo': '{n} jam lalu',
    'dash.reconDaysAgo': '{n} hari lalu',
    'dash.reconPctMatched': 'Tercocok',
    'dash.reconMatchedToday': 'Hari ini',
    'dash.reconQueue': 'Antrian',
    'dash.reconMatchedAmt': 'Nilai cocok',
    'dash.reconSpark7d': '7 hari',
    'dash.reconFilterMatch': 'Cocokkan',
    'dash.reconFilterWarn': 'Tolak/Undo',
    'dash.reconSearch': 'Cari ref / user…',
    'dash.reconNoResults': 'Tidak ada hasil',
    'dash.reconAutoLow': 'Auto-match {n} rendah',
    'dash.reconAllUsers': 'Semua user',
    'dash.reconExportOk': 'Excel timeline diunduh',
    'dash.reconExportFail': 'Gagal export timeline',
    'dash.reconUndoConfirm': 'Urungkan cocokkan ini?',
    'dash.reconUndoTapAgain': 'Ketuk Undo lagi untuk konfirmasi',
    'dash.reconUndoOk': 'Cocokkan di-undo',
    'dash.reconUndoFail': 'Gagal undo',
    'dash.reconUndoLast': 'Undo terakhir',
    'dash.reconUndoLastHint': 'Urungkan cocokkan terakhir',
    'dash.reconNotifyOn': 'Notifikasi rekonsiliasi aktif',
    'dash.reconNotifyOff': 'Notifikasi dimatikan',
    'dash.reconNotifyOnHint': 'Aktifkan notifikasi browser',
    'dash.reconNotifyDenied': 'Izinkan notifikasi di browser',
    'dash.fxSalesTitle': 'Penjualan',
    'dash.fxPendapatan': 'Pendapatan',
    'dash.fxPaid': 'Faktur Lunas',
    'dash.fxUnpaid': 'Faktur Belum Lunas',
    'dash.fxOpenSales': 'Buka faktur',
    'dash.fxPlTitle': 'Laba/Rugi',
    'dash.fxRevenue': 'Pendapatan',
    'dash.fxHpp': 'Nilai HPP',
    'dash.fxOpex': 'Pengeluaran',
    'dash.fxLaba': 'Laba',
    'dash.fxOpenPl': 'Buka laporan omset',
    'dash.fxRange': 'Rentang {range}',
    'dash.fxCompare': '(Dibanding {range})',
    'dash.insightKicker': 'Analytics · Pajak & tren',
    'dash.insightTitle': 'Grafik 12 bulan terakhir',
    'dash.insightTitleYtd': 'Grafik tahun berjalan (YTD)',
    'dash.insightTitleYtdYear': 'Grafik YTD {year}',
    'dash.insightTitleYear': 'Grafik tahun {year}',
    'dash.insightTitle12Year': '12 bulan hingga akhir {year}',
    'dash.insightTitleRange': 'Grafik sesuai rentang tanggal',
    'dash.insightSub': 'Omset, HPP, laba, PPh Final & kelengkapan SPT — ikut filter PT, tahun & tanggal',
    'dash.insightSubLive': '{pt} · {range} · omset/HPP/laba/PPh & kesiapan SPT',
    'dash.insightOpen': 'Buka',
    'dash.insightClose': 'Tutup',
    'dash.expandInsight': 'Perbesar Analytics',
    'dash.insightOmset': 'Omset',
    'dash.insightHpp': 'HPP',
    'dash.insightOpex': 'Opex',
    'dash.insightGross': 'Laba kotor',
    'dash.insightNet': 'Laba bersih',
    'dash.insightPph': 'PPh Final',
    'dash.insightRadialTitle': 'Komposisi keuangan',
    'dash.insightRadialSub': 'Omset per PT · HPP · Opex · PPh',
    'dash.insightRadialTotal': 'Omset periode',
    'dash.insightCompareTitle': 'Omset vs HPP',
    'dash.insightCompareSub': 'Perbandingan bulanan sesuai jendela filter',
    'dash.insightComparePtTitle': 'Omset JGI vs JGT',
    'dash.insightComparePtSub': 'Side-by-side bulanan per PT',
    'dash.insightPlTitle': 'Laba / rugi bulanan',
    'dash.insightPlSub': 'Hijau untung · oranye rugi',
    'dash.insightTaxTitle': 'Estimasi PPh Final',
    'dash.insightTaxSub': 'Relatif ke bulan tertinggi',
    'dash.insightGaugeTitle': 'Kesiapan SPT / data',
    'dash.insightGaugeSub': 'Skor kelengkapan tahun berjalan',
    'dash.insightGaugeLabel': 'Skor',
    'dash.insightFoot':
      'PPh Final diestimasi dari omset × tarif PT (default {rate}% PP 55/2022). Bukan pengganti e-SPT — verifikasi sebelum pelaporan.',
    'dash.insightWindow': 'Jendela tren',
    'dash.insightWin12': '12 bulan',
    'dash.insightWinYear': 'Tahun',
    'dash.insightWinRange': 'Rentang',
    'dash.insightYear': 'Filter tahun',
    'dash.insightYearHint': 'Klik tahun untuk mundur ke data historis',
    'dash.insightSearchLabel': 'Cari bulan',
    'dash.insightApply': 'Terapkan',
    'dash.insightFollow': 'Ikuti filter',
    'dash.insightSearchPh': 'Cari bulan / tahun…',
    'dash.insightMonthsN': '{n} bulan',
    'dash.insightDataMonths': '{n} ada data',
    'dash.insightFiltered': 'hasil filter {n}',
    'dash.insightNoSearch': 'Tidak ada bulan cocok untuk “{q}”',
    'dash.insightTableTitle': 'Rincian bulanan',
    'dash.insightAvg': 'Rata-rata',
    'dash.insightMargin': 'Margin',
    'dash.insightTrendTitle': 'Tren omset & PPh',
    'dash.insightTrendSub': 'Dual-axis · omset kiri · PPh kanan · ikut filter PT & jendela',
    'dash.insightColMonth': 'Bulan',
    'dash.insightColIntensity': 'Intensitas',
    'dash.insightColMom': 'MoM',
    'dash.insightPerPage': 'Per halaman',
    'dash.insightPageAll': 'Semua',
    'dash.insightPagination': 'Navigasi halaman',
    'dash.insightPagePrev': 'Halaman sebelumnya',
    'dash.insightPageNext': 'Halaman berikutnya',
    'dash.insightPageShowing': 'Menampilkan {from}–{to} dari {total}',
    'dash.insightSuggestTitle': 'Saran cerdas',
    'dash.insightSuggestSub': 'Aksi prioritas dari tren, pajak & kelengkapan data',
    'dash.insightSuggestCount': 'saran',
    'dash.insightHealthTitle': 'Radar kesehatan',
    'dash.insightHealthSub': 'Kelengkapan · margin · stabilitas · pajak · densitas',
    'dash.insightHealthScore': 'Skor kesehatan',
    'dash.insightHealthComplete': 'Lengkap',
    'dash.insightHealthMargin': 'Margin',
    'dash.insightHealthStable': 'Stabilitas',
    'dash.insightHealthTax': 'Pajak',
    'dash.insightHealthDensity': 'Densitas',
    'dash.insightHealthCompleteShort': 'Lengkap',
    'dash.insightHealthMarginShort': 'Margin',
    'dash.insightHealthStableShort': 'Stabil',
    'dash.insightHealthTaxShort': 'Pajak',
    'dash.insightHealthDensityShort': 'Dens',
    'dash.insightHeatTitle': 'Heatmap omset',
    'dash.insightHeatSub': 'Intensitas bulanan (0–100 vs puncak)',
    'dash.insightMixTitle': 'Porsi omset per PT',
    'dash.insightMixSub': 'Donut · ikut filter perusahaan',
    'dash.insightMixEmpty': 'Belum ada omset di jendela ini',
    'dash.cashBalance': 'Saldo Kas / Bank',
    'dash.cashSubtitle': 'Mutasi kas periode',
    'dash.bankKicker': 'Treasury',
    'dash.bankTitle': 'Saldo bank per PT',
    'dash.bankSub': 'Tiap PT: 2 BCA · 2 Mandiri · 2 BNI — saldo, last update (tgl/jam/detik) & sumber upload · {date}',
    'dash.bankSubShort': 'Tekan Buka untuk lihat 6 rekening lengkap · {date}',
    'dash.bankExpandHint': 'Semua PT terbuka · posisi per {date}',
    'dash.bankAccountsN': '{n} rekening',
    'dash.bankStaleN': '{n} perlu update',
    'dash.bankExpand': 'Buka',
    'dash.bankClose': 'Tutup',
    'dash.bankDetailHint': '6 rekening · saldo buku, last update, dan sumber upload',
    'dash.bankUpdateSaldo': 'Update saldo',
    'dash.bankUpdateQuick': 'Cepat',
    'dash.bankUpdateRekening': 'Update rekening',
    'dash.bankUpdateShort': 'Update rek.',
    'dash.bankEmptyAlert': '{n} rekening belum punya nomor — isi dulu agar import pintar akurat',
    'dash.bankGoCash': 'Posisi kas PT',
    'dash.bankContinueFrom': 'Lanjut dari {date}',
    'dash.bankColAccount': 'Rekening',
    'dash.bankColNo': 'No.',
    'dash.bankColBalance': 'Saldo',
    'dash.bankColUpdate': 'Update',
    'dash.bankColVia': 'Sumber',
    'dash.bankTotal': 'Total bank',
    'dash.bankOpen': 'Posisi kas',
    'dash.bankOpenShort': 'Kas',
    'dash.bankNoEmpty': 'No. rekening belum diisi',
    'dash.bankViaUnknown': 'Belum ada upload',
    'bankPop.btn': 'Riwayat 6 rekening',
    'bankPop.btnShort': 'Riwayat 6',
    'bankPop.updateRekening': 'Update rekening',
    'bankPop.emptyAcct': 'Isi nomor rekening dulu',
    'bankPop.kicker': 'Treasury · Bank desk',
    'bankPop.title': 'Semua rekening · 12 mutasi terakhir',
    'bankPop.sub':
      'Pusat pantau 6 rekening per PT (2 BCA · 2 Mandiri · 2 BNI): status update, saldo buku, dan mutasi terakhir — siap lanjut import tanpa dobel.',
    'bankPop.how':
      'Cara pakai: pilih PT & rekening di kiri → cek panduan status → buka tautan update (PDF / cepat / kelola) → tinjau mutasi di bawah.',
    'bankPop.refresh': 'Muat ulang data rekening',
    'bankPop.heroShow': 'Buka detail header',
    'bankPop.heroHide': 'Sembunyikan detail header',
    'bankPop.filterTitle': 'Filter periode mutasi',
    'bankPop.filterHint': 'Atur PT & rentang tanggal, lalu Terapkan untuk membuka mutasi lengkap dengan pagination.',
    'bankPop.accounts': '{n} rekening',
    'bankPop.balance': 'Saldo buku',
    'bankPop.lastUpdate': 'Last update',
    'bankPop.via': 'Via',
    'bankPop.continueFrom': 'Lanjut import dari',
    'bankPop.continueHint':
      'Mulai upload e-statement / file bank dari tanggal ini agar tidak overlap dengan mutasi yang sudah tercatat. Tautan di bawah sudah membawa PT, COA bank, no. rekening, dan tanggal lanjut.',
    'bankPop.importStmt': 'E-Statement / PDF',
    'bankPop.importQuick': 'Debit/Kredit Cepat',
    'bankPop.goCash': 'Posisi kas',
    'bankPop.guideEmptyTitle': 'Nomor rekening belum diisi',
    'bankPop.guideEmptyBody':
      'Isi no. rekening dulu di halaman Kelola rekening agar import e-statement & debit/kredit cepat bisa menempel ke slot yang benar.',
    'bankPop.guideStaleTitle': 'Rekening perlu update saldo',
    'bankPop.guideStaleBody':
      'Data terakhir sudah usang. Lanjut import mulai {date} lewat E-Statement/PDF (paling akurat) atau Debit/Kredit Cepat untuk transaksi singkat.',
    'bankPop.guideOkTitle': 'Rekening up-to-date',
    'bankPop.guideOkBody':
      'Status sehat. Cek posisi kas antar rekening, rekonsiliasi, atau buka laporan bank untuk review profesional.',
    'bankPop.hubTitle': 'Pusat tautan update',
    'bankPop.hubSub': 'Semua URL terkait rekening aktif — siap diklik',
    'bankPop.hubMini': '8 tautan kerja',
    'bankPop.hubIntro':
      'Setiap kartu membuka halaman kerja dengan parameter PT / bank / no. rekening / tanggal sudah terisi. Badge “Disarankan” menyesuaikan status rekening yang sedang dibuka.',
    'bankPop.hubRecommended': 'Disarankan',
    'bankPop.hubManage': 'Kelola nomor rekening',
    'bankPop.hubManageDesc':
      'Edit alias, no. rekening, dan mapping slot BCA/Mandiri/BNI per PT. Wajib jika nomor masih kosong.',
    'bankPop.hubStmt': 'Update saldo · E-Statement',
    'bankPop.hubStmtDesc':
      'Upload PDF / file bank pintar. Paling akurat untuk mengejar mutasi harian sampai tanggal lanjut.',
    'bankPop.hubQuick': 'Debit / Kredit cepat',
    'bankPop.hubQuickDesc':
      'Input cepat beberapa baris debit-kredit tanpa PDF. Cocok untuk koreksi kecil atau transaksi mendesak.',
    'bankPop.hubCash': 'Posisi kas & bank',
    'bankPop.hubCashDesc':
      'Lihat saldo gabungan, coverage update, dan papan rekening live per PT.',
    'bankPop.hubRecon': 'Rekonsiliasi bank',
    'bankPop.hubReconDesc':
      'Cocokkan mutasi buku vs bank, selesaikan selisih, dan jaga checklist rekonsiliasi.',
    'bankPop.hubReport': 'Laporan bank',
    'bankPop.hubReportDesc':
      'Ringkasan mutasi bank per periode untuk review manajemen / auditor.',
    'bankPop.hubLedger': 'Buku besar',
    'bankPop.hubLedgerDesc':
      'Buka buku besar PT aktif dengan periode yang sama; pilih COA bank untuk detail jurnal.',
    'bankPop.hubImport': 'Import data',
    'bankPop.hubImportDesc':
      'Pusat import file lain (Excel/jurnal) bila sumber data bukan e-statement murni.',
    'bankPop.lastMoves': '{n} mutasi terakhir (debit/kredit)',
    'bankPop.noMoves': 'Belum ada mutasi di rekening ini.',
    'bankPop.noMovesHint': 'Coba buka bulan ini, ubah filter sumber, atau buat entri cepat.',
    'bankPop.healthOk': 'Semua rekening sehat',
    'bankPop.healthWarn': 'Perlu perhatian',
    'bankPop.openLink': 'Buka',
    'bankPop.modeLast12': '12 terakhir',
    'bankPop.modeBrowse': 'Browse filter',
    'bankPop.mainEmptyTitle': 'Tidak ada rekening cocok filter',
    'bankPop.mainEmptyBody': 'Reset filter status/bank/pencarian untuk melihat daftar lagi.',
    'bankPop.showAllAccounts': 'Tampilkan semua rekening',
    'bankPop.pin': 'Sematkan',
    'bankPop.daysLate': '{n} hari',
    'bankPop.deskMode': 'Mode desk',
    'bankPop.modeWork': 'Kerja',
    'bankPop.modeReview': 'Review',
    'bankPop.checkTitle': 'Checklist harian',
    'bankPop.checkEmpty': 'Isi no. rek kosong ({n})',
    'bankPop.checkStale': 'Update terlambat ({n})',
    'bankPop.checkReview': 'Tandai review hari ini',
    'bankPop.checkRecon': 'Lanjut rekonsiliasi',
    'bankPop.reviewedOk': 'Review hari ini dicatat',
    'bankPop.exportCsv': 'Ekspor CSV mutasi',
    'bankPop.exportEmpty': 'Tidak ada mutasi untuk diekspor',
    'bankPop.exportOk': 'CSV {n} baris diunduh',
    'bankPop.copySummary': 'Salin ringkas',
    'bankPop.summaryCopied': 'Ringkasan disalin',
    'bankPop.batchStale': 'Update {n} terlambat',
    'bankPop.batchNone': 'Tidak ada rekening terlambat ber-nomor',
    'bankPop.batchStart': 'Antrian update {n} rekening — membuka e-statement',
    'bankPop.allHealthyHint': 'Semua sehat · lanjut import bulan ini?',
    'bankPop.shortcuts': 'Keyboard: / cari · j/k pindah · Enter aksi · 1–4 filter · e angka',
    'bankPop.full': 'Perbesar (fullscreen)',
    'bankPop.exitFull': 'Kembalikan ukuran',
    'bankPop.minimize': 'Kecilkan',
    'bankPop.windowControls': 'Kontrol jendela',
    'bankPop.sizeGroup': 'Ukuran popup',
    'bankPop.sizeS': 'Kecil (S)',
    'bankPop.sizeM': 'Sedang (M)',
    'bankPop.sizeL': 'Besar (L)',
    'bankPop.sizeLA': 'Fullscreen (LA)',
    'bankPop.showAmounts': 'Tampilkan angka (auto-sembunyi 60 dtk · E)',
    'bankPop.hideAmounts': 'Sembunyikan angka (E)',
    'bankPop.staleCount': '{n} terlambat',
    'bankPop.emptyCount': '{n} tanpa no. rekening',
    'bankPop.staleShort': '{n} terlambat',
    'bankPop.emptyShort': '{n} kosong',
    'bankPop.quickActions': 'Aksi cepat',
    'bankPop.continueMini': 'Lanjut upload',
    'bankPop.healthLine': '{ok} up-to-date · {stale} terlambat · {empty} kosong',
    'bankPop.periodCustom': 'Kustom',
    'bankPop.acctSearchPh': 'Cari bank, no. rekening, COA, alias…',
    'bankPop.acctFilter': 'Filter status rekening',
    'bankPop.acctAll': 'Semua',
    'bankPop.acctStale': 'Terlambat',
    'bankPop.acctEmpty': 'Kosong',
    'bankPop.acctOk': 'Up-to-date',
    'bankPop.acctNoMatch': 'Tidak ada rekening yang cocok',
    'bankPop.asOf': 'Snapshot · {date}',
    'bankPop.consultantNote': 'Ringkasan treasury · siap review & lanjut import',
    'bankPop.from': 'Dari tanggal',
    'bankPop.to': 'Sampai tanggal',
    'bankPop.search': 'Pencarian',
    'bankPop.searchPh': 'Cari keterangan, ref, sumber…',
    'bankPop.sort': 'Urutkan',
    'bankPop.sortDateDesc': 'Tanggal terakhir',
    'bankPop.sortDateAsc': 'Tanggal awal',
    'bankPop.sortAmtAsc': 'Transaksi kecil → besar',
    'bankPop.sortAmtDesc': 'Transaksi besar → kecil',
    'bankPop.sortNameAsc': 'Nama A → Z',
    'bankPop.thisMonth': 'Lihat bulan ini',
    'bankPop.thisMonthHint': 'Buka mutasi bulan berjalan dengan pagination (100 / 500 / 1000 / all)',
    'bankPop.backLast12': '12 terakhir',
    'bankPop.applyFilter': 'Terapkan filter',
    'bankPop.movesFound': '{n} mutasi cocok',
    'bankPop.perPage': 'Per halaman',
    'bankPop.pageAll': 'All',
    'bankPop.pageMeta': 'Halaman {page} / {pages} · {total} baris',
    'bankPop.revealHint': 'Angka terbuka · auto-sembunyi 60 dtk',
    'bankPop.attentionTitle': 'Perlu perhatian',
    'bankPop.attentionSub': '{n} rekening perlu aksi',
    'bankPop.attnEmpty': 'Kosong',
    'bankPop.attnStale': 'Terlambat',
    'bankPop.bankFilter': 'Filter bank',
    'bankPop.bankAll': 'Semua bank',
    'bankPop.bankOther': 'Lainnya',
    'bankPop.acctSort': 'Urut rekening',
    'bankPop.sortStatus': 'Status dulu',
    'bankPop.sortBalance': 'Saldo terbesar',
    'bankPop.sortBankName': 'Nama bank A–Z',
    'bankPop.copyNo': 'Salin no.',
    'bankPop.copied': 'Tersalin',
    'bankPop.prevAcct': 'Rekening sebelumnya',
    'bankPop.nextAcct': 'Rekening berikutnya',
    'bankPop.netFlow': 'Net mutasi (filter)',
    'bankPop.dcRatio': 'Rasio debit vs kredit',
    'bankPop.channelFilter': 'Filter sumber mutasi',
    'bankPop.chAll': 'Semua sumber',
    'bankPop.chExcel': 'Excel',
    'bankPop.chEstatement': 'E-Statement',
    'bankPop.chQuick': 'Cepat',
    'bankPop.chOther': 'Lainnya',
    'bankPop.sideHint': 'Cari, filter status/bank, lalu klik rekening untuk buka detail + tautan update.',
    'dash.omset': 'Omset',
    'dash.omsetSubtitle': 'Pendapatan',
    'dash.grossProfit': 'Laba Kotor',
    'dash.grossSubtitle': 'Omset − HPP',
    'dash.netProfit': 'Laba Bersih',
    'dash.netSubtitle': 'Setelah biaya operasional',
    'dash.performa': 'Performa',
    'dash.omsetQuickTitle': 'Omset · Bulan Ini & Kemarin',
    'dash.omsetQuickHint': 'Default cepat — 2 bulan saja. Tekan Lihat untuk muat setahun penuh.',
    'dash.showYtd': 'Tampilkan omset Tahun Ini (cek batas PKP)',
    'dash.hideYtd': 'Sembunyikan omset Tahun Ini',
    'dash.pkpNear': 'Mendekati batas PKP Rp 4,8 M',
    'dash.pkpOver': 'Melebihi batas omset PKP Rp 4,8 M',
    'dash.pkpWarn': 'Waspada PKP (≥70% batas)',
    'dash.pkpTitle': 'Batas PKP UMKM',
    'dash.pkpOfLimit': '{pct}% dari Rp 4,8 M',
    'dash.omsetFullHint': 'Data 12 bulan dimuat',
    'dash.omsetMonthly': 'Omset Bulanan',
    'dash.viewYear': 'Lihat Tahun',
    'dash.closeYear': 'Tutup Tahun',
    'dash.pickYear': 'Pilih tahun',
    'dash.thisYear': 'Tahun Ini',
    'dash.fullYear': 'Tahun penuh',
    'dash.detailReport': 'Detail laporan',
    'dash.month': 'Bulan',
    'dash.total': 'Total',
    'dash.total2Months': 'Total 2 bulan',
    'dash.total2MonthsShort': 'Total 2 bln',
    'dash.totalYear': 'Total tahun',
    'dash.totalYearShort': 'Total thn',
    'dash.noOmset': 'Belum ada data omset',
    'dash.thisMonthBadge': 'Bulan Ini',
    'dash.seeMore': 'Lihat Selanjutnya…',
    'dash.yearComplete': 'Tahun {year} lengkap',
    'dash.backTo2Months': 'Kembali ke 2 bulan',
    'dash.breakdown': 'Rincian',
    'dash.byCompany': 'Per Perusahaan',
    'dash.activity': 'Aktivitas',
    'dash.recentJournals': 'Jurnal Terbaru',
    'dash.opsKicker': 'Operasional',
    'dash.opsTitle': 'PT & Jurnal',
    'dash.opsMargin': 'Margin',
    'dash.opsShare': 'Porsi omset {pct}%',
    'dash.opsPtEmpty': 'Belum ada ringkasan per PT untuk periode ini',
    'dash.errSummary': 'Gagal memuat ringkasan dashboard',
    'dash.opsKasbon': 'Kasbon',
    'dash.opsPtCount': '{n} PT',
    'dash.opsGotoOmset': 'Laporan omset',
    'dash.opsZeroHint':
      'Omset periode ini Rp 0. E-statement tersimpan biasanya masuk filter Tahun Ini — ganti periode, atau upload e-statement dulu.',
    'dash.opsFromStmt': 'E-statement',
    'dash.opsOmsetTip': 'Tampil: {shown}\nBuku (semua sumber): {book}\nE-statement: {stmt}',
    'dash.opsHppTip': 'Tampil: {shown}\nBuku (semua sumber): {book}\nE-statement: {stmt}',
    'dash.opsStmtCoverage': 'E-statement {from} → {to} · {n} mutasi',
    'dash.opsDrillJournals': 'Lihat jurnal import',
    'dash.opsCtaUpload': 'Upload e-statement',
    'dash.opsHppPct': 'HPP {pct}% dari omset',
    'dash.opsDetail': 'Detail',
    'dash.opsCompare': 'Perbandingan porsi omset',
    'dash.opsEntries': 'Entri',
    'dash.srcFilterLabel': 'Filter sumber jurnal',
    'dash.srcAll': 'Semua',
    'dash.srcImport': 'E-statement',
    'dash.srcManual': 'Manual',
    'dash.recentHint': 'Hanya dalam {period} · tampil {limit} · urut waktu simpan',
    'dash.recentHintShown':
      'Hanya dalam {period} · menampilkan {shown} entri · batas {limit} · urut waktu simpan',
    'dash.recentAll': 'semua',
    'dash.noJournals': 'Tidak ada jurnal di periode ini.',
    'dash.seeN': 'Lihat {n}',
    'dash.seeAll': 'Lihat Semua',
    'dash.backTo12': 'Kembali ke 12',
    'dash.noMemo': 'Tanpa memo',
    'dash.hideFigures': 'Sembunyikan angka',
    'dash.showFigures': 'Tampilkan angka',
    'dash.pickOmsetYear': 'Pilih tahun omset',
    'dash.pickOmsetYearHint': 'Pilih tahun (2026, 2025, …)',
    'dash.yearAvailable': 'Tersedia',
    'dash.noOtherYears': 'Belum ada tahun lain — muncul otomatis jika ada omset',
    'dash.loadingOmset2m': 'Memuat omset 2 bulan…',
    'dash.loadingJournals': 'Memuat jurnal…',
    'dash.savedAt': 'Disimpan',
    'dash.colHpp': 'HPP',
    'dash.colPt': 'PT',
    'dash.snackSavedRecon': 'Jurnal {ref} tersimpan → antrian rekonsiliasi',
    'dash.snackToJournal': 'Lihat jurnal',
    'dash.snackToRecon': 'Buka rekonsiliasi',
    'dash.vsPrevPeriod': 'Vs periode sebelumnya',
    'dash.vsPrevShort': 'vs lalu',
    'dash.errOmsetYear': 'Gagal memuat omset tahunan',
    'dash.hasOmsetData': 'Ada data omset',
    'dash.limitNext': '{from} → {to}',
    'dash.limitAll': 'semua',

    'period.today': 'Hari Ini',
    'period.yesterday': 'Kemarin',
    'period.thisWeek': 'Minggu Ini',
    'period.thisMonth': 'Bulan Ini',
    'period.thisYear': 'Tahun Ini ({year})',
    'period.last7': '7 Hari',
    'period.last30': '30 Hari',
    'period.last90': '90 Hari',
    'period.monthsAgo1': '1 Bulan Lalu ({month} {year})',
    'period.monthsAgoN': '{n} Bulan Lalu ({month} {year})',
    'period.custom': 'Kustom (manual)',

    'nav.section.monthDesk': 'Kerja Bulan',
    'nav.monthBank': 'Meja Bank',
    'nav.monthTax': 'Meja Pajak',
    'taxDesk.label': 'Alur Meja Pajak',
    'taxDesk.kicker': 'Meja Pajak',
    'taxDesk.title': 'Alur linear pajak',
    'taxDesk.sub': 'Omset → PPh Final → pemotongan → SSP → SPT',
    'taxDesk.stepOmset': 'Omset',
    'taxDesk.stepOmsetHint': 'Dasar pengenaan PPh Final',
    'taxDesk.stepFinal': 'PPh Final',
    'taxDesk.stepFinalHint': '0,5% UMKM per PT',
    'taxDesk.stepWithhold': 'PPh 21/23',
    'taxDesk.stepWithholdHint': 'Bukti potong & payroll',
    'taxDesk.stepSsp': 'SSP',
    'taxDesk.stepSspHint': 'Setor & e-billing',
    'taxDesk.stepSpt': 'SPT Masa',
    'taxDesk.stepSptHint': 'Pack & kelengkapan',
    'taxDesk.pph21Link': 'Kalkulator PPh 21',
    'meja.kicker': 'Meja bulan',
    'meja.title': '{n} tugas menunggu',
    'meja.titleClear': 'Bulan ini bersih — lanjut review LK',
    'meja.sub': 'Alur satu genggaman: bank → HR → aset → pajak → LK → kunci periode.',
    'meja.subShort': 'Bank → HR → aset → pajak → LK → kunci.',
    'meja.allClear': 'Tidak ada antrian kritis',
    'meja.stepBank': 'Bank',
    'meja.stepHr': 'HR',
    'meja.stepFa': 'Aset',
    'meja.stepTax': 'Pajak',
    'meja.stepLk': 'LK',
    'meja.stepClose': 'Kunci',
    'fcb.kicker': 'Konteks kerja',
    'fcb.title': 'Filter PT & periode',
    'fcb.sub': 'Filter PT & periode untuk dashboard, jurnal, rekonsiliasi, saldo awal, dan laporan.',
    'fcb.dirty': 'Belum diterapkan',
    'fcb.savedViews': 'Tersimpan',
    'fcb.saveView': 'Simpan view',
    'fcb.viewName': 'Nama view',
    'fcb.viewSaved': 'View tersimpan',
    'dash.kpiWhy': 'Lihat sumber →',
    'inbox.kicker': 'Exception inbox',
    'inbox.title': '{n} item perlu perhatian',
    'inbox.todayKicker': 'Hari ini',
    'inbox.todayTitle': '{n} yang harus dikerjakan',
    'inbox.todaySub': 'Antrian aksi gabungan: jurnal, rekonsiliasi, pajak, absensi, AR/AP, dan tutup bulan.',
    'inbox.todaySubShort': 'Antrian aksi: jurnal, pajak, absensi, AR/AP.',
    'inbox.sub': 'Antrian gabungan dari jurnal, rekonsiliasi, kasbon, kualitas data, dan tutup bulan.',
    'inbox.subShort': 'Antrian gabungan jurnal, rekonsiliasi, kasbon & tutup bulan.',
    'inbox.why': 'Lihat detail →',
    'inbox.samples': 'Contoh ref',
    'inbox.unbal': 'Jurnal tidak balance',
    'inbox.aging': 'Recon aging 30+',
    'inbox.recon': 'Rekonsiliasi pending',
    'inbox.kasbon': 'Kasbon pending',
    'inbox.quality': 'Kualitas data / gap',
    'inbox.npwp': 'NPWP kosong',
    'inbox.tax': 'Deadline pajak',
    'inbox.attendance': 'Gap absensi bulan ini',
    'inbox.lock': 'Periode terkunci',
    'inbox.invOverdue': 'Invoice jatuh tempo',
    'inbox.invUnpaid': 'Invoice belum lunas',
    'inbox.billOverdue': 'Tagihan vendor jatuh tempo',
    'inbox.billUnpaid': 'Tagihan vendor belum lunas',
    'inbox.faDepreciation': 'Penyusutan aset belum dijalankan',
    'inbox.recurringDue': 'Jurnal berulang belum dijalankan',
    'inbox.journalApproval': 'Jurnal menunggu approval',
    'inbox.lowStock': 'Stok produk rendah',
    'plb.locked': 'Bulan {month}/{year} terkunci',
    'plb.signed': 'Bulan {month}/{year} sudah di-signoff',
    'plb.lockedHint': 'Posting jurnal biasa diblok — buka kunci di Tutup Bulan bila perlu.',
    'plb.signedHint': 'Paraf aktif. Review checklist sebelum ubah data periode ini.',
    'plb.open': 'Buka Tutup Bulan',

    'qj.kicker': 'Transaksi cepat',
    'qj.title': 'Debit / Kredit Cepat',
    'qj.sub': 'Simpan → masuk antrian rekonsiliasi untuk dicocokkan ke statement',
    'qj.company': 'Perusahaan',
    'qj.pickPt': 'Pilih PT',
    'qj.date': 'Tanggal',
    'qj.debit': 'Akun Debit',
    'qj.credit': 'Akun Kredit',
    'qj.pickDebit': 'Pilih akun debit',
    'qj.pickCredit': 'Pilih akun kredit',
    'qj.accountSearch': 'Ketik kode atau nama akun…',
    'qj.accountNoMatch': 'Tidak ada akun yang cocok',
    'ss.searchPh': 'Cari kode, nama, nomor…',
    'ss.noMatch': 'Tidak ada yang cocok',
    'bsp.searchPh': 'Cari bank, kode, no rekening…',
    'qj.amount': 'Nominal',
    'qj.amountDebit': 'Debit (angka)',
    'qj.amountCredit': 'Kredit (angka)',
    'qj.addToTable': 'Tambah ke tabel',
    'qj.singleSub': 'Isi debit/kredit angka → Tambah ke tabel bawah → simpan antrian ke rekonsiliasi',
    'qj.singleQueueTitle': 'Antrian entri tunggal',
    'qj.singleQueueSub': '{n} baris siap disimpan',
    'qj.singleQueueEmpty': 'Belum ada baris — isi form lalu klik Tambah ke tabel.',
    'qj.clearQueue': 'Kosongkan',
    'qj.saveQueue': 'Simpan antrian ({n})',
    'qj.errNoSingleQueue': 'Belum ada baris terpilih di antrian.',
    'qj.memo': 'Memo / keterangan',
    'qj.memoPh': 'Catatan singkat…',
    'qj.note': 'Catatan',
    'qj.save': 'Simpan Jurnal',
    'qj.refTemp': 'sementara · dikunci unik saat simpan',
    'qj.refSaved': 'tersimpan',
    'qj.refLoading': 'memuat…',
    'qj.shortcutHint': 'Ctrl+Enter antri · Esc reset · Ctrl+Z undo',
    'qj.undoLast': 'Undo',
    'qj.undoLastHint': 'Batalkan baris terakhir di antrian (Ctrl+Z)',
    'qj.copyToForm': 'Salin ke form',
    'qj.copyToFormHint': 'Muat baris ini ke form Entri Tunggal untuk diedit',
    'qj.formatHint': 'Format: 300,000.81 · paste ID 300.000,81 aman · isi salah satu sisi Debit atau Kredit',
    'qj.staging': 'Draf',
    'qj.errIncomplete': 'Lengkapi PT, deskripsi, kas/bank, akun lawan, dan angka Debit atau Kredit',
    'qj.errSave': 'Gagal menyimpan jurnal',
    'qj.savedRef': 'Tersimpan · Ref ID',
    'qj.track': 'Lacak',
    'qj.openRecon': 'Buka Rekonsiliasi',
    'qj.refId': 'Ref ID',
    'qj.pageKicker': 'Transaksi',
    'qj.pageHint': 'Nominal otomatis mengenali format lama (titik) & baru (koma) — contoh 300.000,81 → 300,000.81',
    'qj.linkJournals': 'Jurnal',
    'qj.openReports': 'Lihat laporan',
    'qj.openBs': 'Neraca',
    'qj.openLk': 'Laporan LK',
    'qj.mutasiTitle': 'Mutasi rekening terbaru',
    'qj.mutasiSub': 'Dari e-statement / jurnal yang sudah masuk buku. Klik baris untuk isi jurnal cepat.',
    'qj.mutasiEmpty': 'Belum ada mutasi untuk PT ini. Unggah e-statement atau pilih rekening dulu.',
    'qj.mutasiUse': 'Isi jurnal',
    'qj.mutasiOpen': 'Lacak',
    'qj.stmtPostedTitle': 'Jurnal dari mutasi yang sudah diterima',
    'qj.stmtPostedSub': 'Baris e-statement yang sudah di-ACC ke buku. Lanjutkan multi-baris untuk yang belum masuk.',
    'qj.stmtPostedEmpty': 'Belum ada jurnal e-statement. Unggah mutasi di tab Upload pintar, lalu ACC.',
    'qj.stmtPostedRefresh': 'Muat ulang',
    'qj.savedNext': 'Lanjut ke laporan',
    'qj.mode.label': 'Mode entri',
    'qj.mode.upload': 'Upload pintar',
    'qj.mode.manual': 'Multi-baris',
    'qj.mode.single': 'Entri tunggal',
    'qj.health.ok': 'Siap lanjut',
    'qj.health.warn': 'Perlu perhatian',
    'qj.health.bankOk': 'Bank siap',
    'qj.health.bankNeed': 'Pilih PT + bank',
    'qj.health.selected': 'Terpilih {n}',
    'qj.health.invalid': 'Invalid {n}',
    'qj.health.needCheck': 'Perlu cek {n}',
    'qj.health.volume': 'D {d} · K {c}',
    'qj.health.rows': '{n} baris',
    'qj.sec.identity': 'Identitas',
    'qj.sec.amount': 'Nilai',
    'qj.sec.bank': 'Kas / Bank',
    'qj.sec.contra': 'Akun lawan',
    'qj.sec.meta': 'Meta',
    'qj.empty.uploadTitle': 'Belum ada baris hasil parse',
    'qj.empty.uploadSub': 'Pilih PT & rekening, unggah bukti, lalu Parse Otomatis.',
    'qj.showDemo': 'Lihat contoh',
    'qj.hideDemo': 'Sembunyikan contoh',
    'qj.snackSaved': 'Tersimpan {ref} · {n} baris',

    'month.0': 'Januari',
    'month.1': 'Februari',
    'month.2': 'Maret',
    'month.3': 'April',
    'month.4': 'Mei',
    'month.5': 'Juni',
    'month.6': 'Juli',
    'month.7': 'Agustus',
    'month.8': 'September',
    'month.9': 'Oktober',
    'month.10': 'November',
    'month.11': 'Desember',
    'monthShort.0': 'Jan',
    'monthShort.1': 'Feb',
    'monthShort.2': 'Mar',
    'monthShort.3': 'Apr',
    'monthShort.4': 'Mei',
    'monthShort.5': 'Jun',
    'monthShort.6': 'Jul',
    'monthShort.7': 'Agu',
    'monthShort.8': 'Sep',
    'monthShort.9': 'Okt',
    'monthShort.10': 'Nov',
    'monthShort.11': 'Des',

    'tasya.name': 'Tasya',
    'tasya.fabHover':
      'Halo! Nama saya Tasya 🎀\nSiap ajar menu + cek cepat (setelah login)!',
    'tasya.status': 'Online · Siap bantu',
    'tasya.welcome':
      'Halo! Nama saya Tasya 🎀 Asisten akuntansi JasaPembayaran.\n\nSaya hanya untuk akun yang sedang login.\n• Mengajar cara pakai semua menu\n• Cek cepat (jumlah jurnal/COA/PT)\n• Jelaskan 1 Ref jika kamu sebutkan\n\nSaya tidak mengubah data sistem, dan tidak membagikan detail ke orang luar.',
    'tasya.placeholder': 'Hai Tasya, mau tanya…',
    'tasya.send': 'Kirim',
    'tasya.open': 'Sapa Tasya',
    'tasya.close': 'Tutup',
    'tasya.clear': 'Hapus chat',
    'tasya.hint':
      'Enter kirim · Hanya tanya–jawab · Data hanya milik akun login · Tasya tidak ubah sistem',
    'tasya.error': 'Tasya belum bisa menjawab. Coba lagi sebentar.',
    'tasya.needLogin': 'Tasya hanya tersedia setelah login. Silakan masuk dulu.',
    'tasya.emptyReply': 'Hmm, belum ada jawaban. Coba ulangi pertanyaannya.',
    'tasya.thinking': 'Tasya lagi mikir…',
    'tasya.quickTitle': 'Saran pertanyaan',
    'tasya.q1': 'Cara impor e-statement langkah demi langkah?',
    'tasya.q2': 'Apa beda JGI dan JGT di website ini?',
    'tasya.q3': 'Cara hitung & posting PPh Final 0.5%?',
    'tasya.q4': 'Cara pakai Debit/Kredit Cepat di dashboard?',
    'tasya.q5': 'Alur rekonsiliasi setelah simpan jurnal?',
    'tasya.q6': 'Di mana lihat laporan omset & laba rugi?',
    'tasya.page.dash': 'Anda di Dashboard — KPI, upload pintar, jurnal cepat',
    'tasya.page.stmt': 'Anda di E-Statement Pintar — upload & mapping AI',
    'tasya.page.recon': 'Anda di Rekonsiliasi — cocokkan statement vs jurnal',
    'tasya.page.tax': 'Anda di Pusat Pajak — PPh Final & SPT',
    'tasya.page.master': 'Anda di Master akun / rekening bank',
    'tasya.page.reports': 'Anda di Laporan — filter PT & periode',
    'tasya.page.journals': 'Anda di Jurnal — Umum / Penyesuaian / Pembetulan / Penutup',
    'tasya.page.generic': 'Halaman aktif: {path}',

    'tsy.kicker': 'Kontrol',
    'tsy.title': 'Tasya Livechat',
    'tsy.sub': 'Atur teks selamat datang, gelembung FAB, status, placeholder, dan saran pertanyaan. Perubahan langsung untuk semua user login.',
    'tsy.statusCustom': 'Teks kustom aktif',
    'tsy.statusDefault': 'Pakai default sistem',
    'tsy.unsaved': 'Belum disimpan',
    'tsy.unsavedBar': 'Ada perubahan belum disimpan',
    'tsy.discard': 'Buang',
    'tsy.updated': 'Diubah {at} · {by}',
    'tsy.reset': 'Kembalikan default',
    'tsy.resetShort': 'Default',
    'tsy.save': 'Simpan teks',
    'tsy.saveShort': 'Simpan',
    'tsy.loading': 'Memuat pengaturan Tasya…',
    'tsy.loadFail': 'Gagal memuat pengaturan Tasya',
    'tsy.saveFail': 'Gagal menyimpan',
    'tsy.saved': 'Teks Tasya tersimpan',
    'tsy.resetOk': 'Kembali ke teks default',
    'tsy.needWelcome': 'Isi teks selamat datang ID dan EN',
    'tsy.needFab': 'Isi teks gelembung FAB ID dan EN',
    'tsy.needStatus': 'Isi status online ID dan EN',
    'tsy.needPlaceholder': 'Isi placeholder ID dan EN',
    'tsy.needQuickTitle': 'Isi judul saran ID dan EN',
    'tsy.needSuggestion': 'Isi saran #{n} ID dan EN',
    'tsy.tooLongWelcome': 'Teks selamat datang terlalu panjang',
    'tsy.tooLongFab': 'Teks FAB terlalu panjang',
    'tsy.welcomeTitle': 'Pesan selamat datang',
    'tsy.welcomeHint': 'Muncul sebagai pesan pertama saat chat Tasya dibuka.',
    'tsy.welcomePhId': 'Tulis sapaan & ringkasan kemampuan Tasya…',
    'tsy.welcomePhEn': 'Write Tasya’s greeting & capability summary…',
    'tsy.fabTitle': 'Gelembung tombol (FAB)',
    'tsy.fabHint': 'Teks singkat di samping avatar Tasya di pojok layar.',
    'tsy.chromeTitle': 'Status & input',
    'tsy.chromeHint': 'Baris status di header chat dan placeholder kotak ketik.',
    'tsy.statusLabel': 'Status online',
    'tsy.placeholderLabel': 'Placeholder input',
    'tsy.suggestTitle': 'Saran pertanyaan',
    'tsy.suggestHint': 'Chip cepat di bawah pesan selamat datang (6 item).',
    'tsy.quickTitleLabel': 'Judul blok saran',
    'tsy.suggestPh': 'Saran #{n}',
    'tsy.previewTitle': 'Pratinjau live',
    'tsy.previewHint': 'Mengikuti bahasa UI aktif (bukan tab edit).',
    'tsy.previewPanel': 'Chat',
    'tsy.previewFab': 'FAB',
    'tsy.previewNow': 'sekarang',
    'tsy.editLang': 'Bahasa yang diedit',
    'tsy.tipsTitle': 'Tips pengaturan',
    'tsy.tip1': 'Edit ID dan EN bergantian lewat tab bahasa di atas form.',
    'tsy.tip2': 'FAB sebaiknya singkat (1–2 baris) agar tidak menutup konten.',
    'tsy.tip3': 'Setelah Simpan, chat Tasya langsung memakai teks baru tanpa refresh penuh.',
    'tsy.langId': 'Bahasa Indonesia',
    'tsy.langEn': 'English',
  } as const;

const messagesEn = {
    'lang.id': 'ID',
    'lang.en': 'EN',
    'lang.idFull': 'Indonesian',
    'lang.enFull': 'English',

    'common.menu': 'Menu',
    'common.home': 'Home',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.backHint': 'Previous page',
    'common.nextHint': 'Next page (after Back)',
    'common.close': 'Close',
    'common.reset': 'Reset',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.done': 'Done',
    'common.pickDate': 'Pick a date',
    'common.all': 'All',
    'common.detail': 'Detail',
    'common.loading': 'Loading…',
    'common.retry': 'Retry',
    'common.search': 'Search',

    'auth.logout': 'Log out',
    'auth.username': 'Username',
    'auth.password': 'Password',
    'auth.remember': 'Stay signed in on this device',
    'auth.signIn': 'Sign in',
    'auth.badCredentials': 'Username or password does not match',
    'auth.tagline': 'One workspace for journals, reports, banking, and tax — tidy from day one.',
    'auth.brandEyebrow': 'Modern finance · Audit ready',
    'auth.headline': 'Clean books. Clear reports. Confident decisions.',
    'auth.formLead': 'Sign in to your account to continue.',
    'auth.point1': 'Statements & ledger connected — no messy spreadsheets',
    'auth.point2': 'Banking, reconciliation, and tax in one workflow',
    'auth.point3': 'Executive dashboard that points to today’s actions',
    'auth.tasyaTap': 'Say hi to Tasya',
    'auth.tasyaTapHint': 'Tap / touch Tasya for tip + voice · auto-mute when done',
    'auth.tasyaIntroHint': 'Voice {n}/{total} · then auto-mute',
    'auth.tasyaMutedHint': 'Muted · tap Tasya to hear another tip',
    'auth.tasyaCountdown': 'Starting in {n}',
    'auth.tasyaCountdownHint': 'Preparing 5 random tips…',
    'auth.tasyaCountdownLabel': 'Start',
    'auth.tasyaTapToHear': 'Tap Tasya so you can hear my voice',
    'auth.tasyaTapToHearHint': 'Tap / touch Tasya’s card — 5 tips play, then mute',
    'auth.tasyaEnableSound': 'Enable Tasya’s voice',
    'auth.tasyaEnableHint': 'Browser blocked autoplay — press the button below',
    'auth.tasyaBlockedMsg': 'Sound still blocked. Press “Enable Tasya’s voice” again.',
    'auth.tasyaErrorMsg': 'Could not play sound. Try the button again.',
    'auth.tasyaOnline': 'Online',
    'auth.tasyaVoiceOn': 'Voice on',
    'auth.tasyaVoiceOff': 'Voice off',
    'auth.tasyaLine1':
      'Hi, I’m Tasya. Welcome to Jasa Pembayaran. Sign in calmly — I’ve got you.',
    'auth.tasyaLine2':
      'One sign-in, then the dashboard greets you with a clear, action-ready summary.',
    'auth.tasyaLine3':
      'Cash, bank, and cash flow are easy to watch — no spreadsheet hopping needed.',
    'auth.tasyaLine4':
      'Receivables and payables stay tame with a daily check. I’ll help keep the rhythm.',
    'auth.tasyaLine5':
      'Smart bank matching lines up statements with journals so balances stop feeling mysterious.',
    'auth.tasyaLine6':
      'Tax, filings, and deadlines live here. On time means a calmer mind.',
    'auth.tasyaLine7':
      'Reports are built audit-ready and decision-ready — pretty and trustworthy.',
    'auth.tasyaLine8':
      'Stay signed in on this device so your next session feels instantly comfortable.',
    'auth.tasyaLine9':
      'Lost in the menus? Tap me. I’ll point a simple path, no drama.',
    'auth.tasyaLine10':
      'Several entities can live cleanly in one shared workspace.',
    'auth.tasyaLine11':
      'Reconciliation isn’t scary. We break it down gently until the numbers truly match.',
    'auth.tasyaLine12':
      'Attendance and staff advances connect so ops and finance stay in sync.',
    'auth.tasyaLine13':
      'Busy day? Start with the dashboard action queue. Finish what matters first.',
    'auth.tasyaLine14':
      'Balance sheet and P&L drill all the way to the ledger. Clarity to the root.',
    'auth.tasyaLine15':
      'Got a variance? Don’t panic. We’ll trace it together until we find the source.',
    'auth.tasyaLine16':
      'A tidy journal today saves tomorrow’s audit. Small habit, big payoff.',
    'auth.tasyaLine17':
      'You’re protected: secure connection, encrypted data, a comfortable session.',
    'auth.tasyaLine18':
      'From petty cash to big tax, the flow can stay light and orderly.',
    'auth.tasyaLine19':
      'Good decisions grow from clean data. Let’s tidy the numbers together.',
    'auth.tasyaLine20':
      'I’m here so you don’t face noisy numbers alone.',
    'auth.tasyaLine21':
      'Matched bank balances make nights calmer. Align them, then rest.',
    'auth.tasyaLine22':
      'Modern finance is simple: clean, fast, and ready for decisions.',
    'auth.tasyaLine23':
      'A small tip today can save hours next week. Consistency wins.',
    'auth.tasyaLine24':
      'We simplify the hard parts and prioritize what matters. The rest can wait.',
    'auth.tasyaLine25':
      'Clean books aren’t a dream. They’re a habit you can build gently.',
    'auth.tasyaLine26':
      'Tax, banking, and reports can move together without scattered-file drama.',
    'auth.tasyaLine27':
      'If you’re tired, rest a moment. The numbers can wait. So can I.',
    'auth.tasyaLine28':
      'Great finance teams keep a daily rhythm. I’ll help you hold yours.',
    'auth.tasyaLine29':
      'Ready for more confident decisions? Sign in and let the data speak.',
    'auth.tasyaLine30':
      'Thanks for being here. Let’s make finance feel lighter today.',
    'auth.sessionCountdown': 'Session: {time} to logout',
    'auth.sessionShort': 'Session {time}',
    'auth.idleExpired': 'Session ended after 24 hours of inactivity. Please sign in again.',
    'auth.sessionHint': 'Your session ends automatically after 24 hours of inactivity.',
    'auth.secureNote': 'End-to-end encrypted',
    'auth.panelBadge': 'Secure session',
    'auth.systemStatus': 'Systems nominal',
    'auth.usernamePh': 'Username',
    'auth.passwordPh': 'Password',
    'auth.showPassword': 'Show password',
    'auth.hidePassword': 'Hide password',

    'device.label': 'Device mode',
    'device.desktop': 'Desktop',
    'device.tablet': 'Tablet',
    'device.hp': 'Phone',
    'device.desktopHint': 'Full screen width',
    'device.tabletHint': '768px preview',
    'device.hpHint': '390px preview',
    'device.fullWidth': 'Full',
    'device.previewHint': 'Layout preview',
    'profile.myProfile': 'My Profile',
    'profile.myAccount': 'My Account',
    'profile.myTask': 'My Tasks',
    'profile.langLabel': 'Language',
    'profile.privacyHint': 'Hide sensitive amounts on screen',
    'profile.salary': 'Salary',
    'profile.commission': 'Commission',
    'profile.payLabel': 'Salary and commission',
    'profile.payDemo': 'Sample',
    'profile.position': 'Position',
    'profile.positionDemo': 'Staff (sample)',
    'profile.joinedAt': 'Joined',
    'profile.lastAttendance': 'Last attendance',
    'profile.secWork': 'Work info',
    'profile.secSession': 'Active session',
    'profile.sessionOn': 'Active',
    'profile.sessionWarn': 'Logging out soon',
    'profile.secPrefs': 'Preferences',
    'profile.secMenu': 'Account menu',
    'profile.menuPeek': 'Settings',
    'profile.expandAll': 'Expand all',
    'profile.collapseAll': 'Collapse all',
    'profile.fillTitle': 'Protected access',
    'profile.fillHint': 'Active session · account secured',
    'theme.label': 'Appearance',
    'theme.light': 'Light',
    'theme.dark': 'Dark',
    'switch.localeTitle': 'Changing language',
    'switch.localeToId': 'Switching to Indonesian…',
    'switch.localeToEn': 'Switching to English…',
    'switch.localeSub': 'Updating the whole interface',
    'switch.localeStepUi': 'Loading interface text…',
    'switch.localeStepLogin': 'Syncing the sign-in page…',
    'switch.localeStepApp': 'Applying across the app…',
    'switch.authChipLocale': 'Language',
    'switch.authChipTheme': 'Theme',
    'switch.authChipSession': 'Session',
    'switch.themeTitle': 'Changing appearance',
    'switch.themeToLight': 'Light mode',
    'switch.themeToDark': 'Dark mode',
    'switch.themeSub': 'Applying colors & contrast',
    'switch.pageTitle': 'Loading page',
    'switch.pageTo': 'Going to',
    'switch.pageSub': 'Please wait a moment…',
    'switch.bootTitle': 'Starting app',
    'switch.bootSub': 'Loading session & interface…',
    'switch.authTitle': 'Signing in',
    'switch.authSub': 'Preparing your workspace…',
    'switch.authStepLocale': 'Loading interface language…',
    'switch.authStepTheme': 'Applying theme & colors…',
    'switch.authStepAuth': 'Verifying account…',
    'switch.authStepDash': 'Opening dashboard…',
    'privacy.hideAll': 'Hide all amounts',
    'privacy.showAll': 'Show all amounts',

    'quality.readyReview': 'Ready for consultant review',
    'quality.needComplete': 'Data needs completion',
    'quality.notReadySpt': 'Not ready for tax filing',

    'notif.tooltip': 'Operations inbox — reconciliation & completeness',
    'notif.kicker': 'Operations inbox',
    'notif.title': 'Notifications',
    'notif.alertCount': '{n} alerts',
    'notif.reload': 'Refresh',
    'notif.matched': 'Reconciled',
    'notif.pendingMatch': 'Pending match',
    'notif.dataScore': 'Data score',
    'notif.recon': 'Reconciliation',
    'notif.task': 'Task',
    'notif.count': 'Count',
    'notif.reconSafe': 'Reconciliation clear — no tasks',
    'notif.reconSafeShort': 'Reconciliation clear',
    'notif.reconWaiting': '{n} reconciliation tasks waiting',
    'notif.quality': 'Completeness',
    'notif.alert': 'Alert',
    'notif.qualitySafe': 'Data complete — no alerts',
    'notif.highRisk': 'High risk',
    'notif.highRiskDetail': 'Needs manual review before matching',
    'notif.medRisk': 'Medium risk',
    'notif.medRiskDetail': 'Check direction / date / amount',
    'notif.lowRisk': 'Ready to auto-match',
    'notif.lowRiskDetail': 'Low risk — can batch match',
    'notif.aging': 'Aging > 30 days',
    'notif.agingDetail': 'Statements unmatched for a long time',
    'notif.dup': 'Duplicate groups',
    'notif.dupDetail': 'Compare in comparison studio',
    'notif.group': '1↔N / N↔1 candidates',
    'notif.groupDetail': 'Group matches available',
    'notif.pendingTasks': 'Waiting tasks',
    'notif.pendingDetail': 'Suggested pairs ready to review',
    'notif.taskList': 'Task list',
    'notif.taskAmount': '{amount}',
    'notif.npwpEmpty': 'Missing tax ID',
    'notif.critical': 'Critical findings',
    'notif.criticalDetail': 'Review in data completeness',
    'notif.gap': 'Statement gaps',
    'notif.gapDetail': 'Months without e-statement',
    'notif.scoreLabel': 'Data score {score}',
    'notif.openRecon': 'Open Reconciliation',
    'notif.openQuality': 'Open Completeness',
    'notif.fillNpwp': 'Complete tax ID',
    'notif.checkQuality': 'Check data completeness',
    'notif.qualityOk': 'Identity & completeness look good',
    'notif.hr': 'HR / Advances',
    'notif.hrOk': 'No HR / advance tasks',
    'notif.hrIncomplete': '{n} active employees with incomplete data ({pct}%)',
    'notif.hrIncompleteDetail': 'Complete NIK/tax ID for active staff (resigned ignored)',
    'notif.hrMissingNpwp': '{n} active employees missing tax ID',
    'notif.hrMissingNpwpDetail': 'Fill tax ID on active employee master',
    'notif.hrMissingNik': '{n} active employees missing NIK',
    'notif.hrMissingNikDetail': 'Fill NIK on active employee master',
    'notif.kasbonPending': 'Advances awaiting approval',
    'notif.kasbonPendingDetail': 'Open Employees & Payroll to Approve / Reject',
    'notif.aiConsDetail': 'AI already executed — please cross-check',
    'notif.markReviewed': 'Mark reviewed',
    'notif.markAllReviewed': 'Clear all AI',
    'notif.openLink': 'Open',
    'notif.tax': 'Tax due dates',
    'notif.taxOverdue': 'Tax overdue',
    'notif.taxH3': 'Tax due in 3 days',
    'notif.taxH7': 'Tax due in 7 days',

    'nav.section.main': 'Main',
    'nav.section.journal': 'Journal Book',
    'nav.section.cashImport': 'Cash & Import',
    'nav.section.trx': 'Transactions',
    'nav.section.master': 'Master Data',
    'nav.section.cash': 'Cash & Bank',
    'nav.section.report': 'Reports',
    'nav.section.classify': 'Classification & Analysis',
    'nav.section.tax': 'Tax',
    'nav.section.customer': 'Customer',
    'nav.section.control': 'Control',
    'nav.dashboard': 'Dashboard',
    'nav.calendar': 'Calendar',
    'nav.activities': 'Activities',
    'nav.reminders': 'Reminders',
    'nav.periodClose': 'Period Close',
    'nav.closeChecklist': 'Close Checklist',
    'nav.quickJournal': 'Quick Journal',
    'nav.multiJournal': 'Create Journal',
    'nav.journals': 'Journal',
    'nav.journalsHub': 'Journal Hub',
    'nav.generalJournal': 'Journal',
    'nav.closeWizard': 'Month Close',
    'nav.lookupRef': 'Find Ref ID',
    'nav.correction': 'Correction',
    'nav.openingBalance': 'Opening Balance',
    'nav.importGroup': 'Import & Statement',
    'nav.statements': 'Smart E-Statement',
    'nav.import': 'Import Data',
    'nav.accounts': 'Account List',
    'nav.employees': 'Employees & Payroll',
    'nav.attendance': 'Employee Attendance',
    'nav.payslips': 'Payslips',
    'nav.hrPortal': 'My Portal',
    'nav.reconciliation': 'Reconciliation',
    'nav.reconPendingTip': '{n} pending mutations in reconciliation queue',
    'nav.pendingCount': '{n} pending',
    'nav.cashBank': 'Cash/Bank Position',
    'nav.updateRekening': 'Bank Accounts',
    'nav.cashFlow': 'Cash Flow',
    'nav.cashForecast': 'Cash Forecast',
    'nav.reportsHub': 'Reports Hub',
    'nav.downloadReports': 'Download Reports',
    'nav.coreReports': 'Core Reports',
    'nav.financialStatements': 'Financial Statements',
    'nav.comparative': 'YoY Comparison',
    'nav.bankReport': 'By Bank/Account',
    'nav.intercompany': 'Intercompany',
    'nav.budget': 'Budget vs Actual',
    'nav.ledger': 'General Ledger',
    'nav.trialBalance': 'Trial Balance',
    'nav.incomeStatement': 'Income Statement',
    'nav.balanceSheet': 'Balance Sheet',
    'nav.omsetYearly': 'Annual Revenue',
    'nav.assets': 'Assets Report',
    'nav.liabilities': 'Liabilities',
    'nav.equity': 'Equity',
    'nav.revenue': 'Revenue',
    'nav.expense': 'Expenses',
    'nav.ar': 'Accounts Receivable',
    'nav.ap': 'Accounts Payable',
    'nav.depreciation': 'Depreciation',
    'nav.inventory': 'Inventory',
    'nav.cogs': 'COGS',
    'nav.accrual': 'Accrual vs Cash',
    'nav.companies': 'Companies & Tax ID',
    'nav.clients': 'Clients / Taxpayers',
    'nav.engagements': 'Engagements & Fees',
    'nav.invoices': 'Invoice & Proforma',
    'nav.vendorBills': 'Vendor Bills',
    'nav.fixedAssets': 'Fixed Assets',
    'nav.recurringJournals': 'Recurring Journals',
    'nav.journalApprovals': 'Journal approvals',
    'nav.dimensions': 'Dimensions',
    'nav.marketing': 'Marketing & WhatsApp',
    'nav.whatsapp': 'WhatsApp',
    'nav.kurs': 'FX Fee Calculator',
    'nav.products': 'Products',
    'nav.taxHub': 'Tax Center',
    'nav.taxHubHome': 'Final Income Tax 0.5%',
    'nav.taxCalendar': 'Tax Calendar',
    'nav.taxVat': 'VAT Summary',
    'nav.taxPph21': 'Art.21 Calculator',
    'nav.sptMasa': 'Periodic Tax Pack',
    'nav.withholdings': 'Withholding Tax',
    'nav.ssp': 'Tax Payment / e-Bupot',
    'nav.fiscal': 'Fiscal Adjustments',
    'nav.taxDocuments': 'Letters & Files',
    'nav.taxRequests': 'Tax Requests',
    'nav.taxRequestsMe': 'My Requests',
    'nav.customerPortal': 'Customer Portal',
    'nav.customers': 'Manage Customers',
    'nav.consolidated': 'JGI+JGT Consolidation',
    'nav.unearned': 'Unearned / DP',
    'nav.quality': 'Data Completeness',
    'nav.audit': 'Audit Trail',
    'nav.backup': 'Backup & Restore',
    'nav.users': 'Users & Access',
    'nav.tasya': 'Tasya Livechat',

    'fav.title': 'Favorites',
    'fav.emptyEdit': 'Tap the pin icon on a menu item below to add it',
    'fav.empty': 'No favorites yet — tap the pin to start',
    'fav.save': 'Save',
    'fav.cancel': 'Cancel',
    'fav.dirtyHint': 'Unsaved changes — open pin mode then Save',
    'fav.manage': 'Manage favorite pins',
    'fav.done': 'Done editing pins',
    'fav.pin': 'Pin to Favorites',
    'fav.unpin': 'Unpin',

    'dash.overview': 'Executive overview',
    'dash.title': 'Finance dashboard',
    'dash.heroSub': 'Cash, receivables–payables, tax, and today’s actions — ready to decide.',
    'dash.heroFocus': 'Work focus',
    'dash.heroPillCash': 'Cash & bank',
    'dash.heroPillAr': 'Receivables',
    'dash.heroPillTax': 'Tax',
    'dash.heroPillAction': 'Today’s actions',
    'dash.activePeriod': 'Active period',
    'dash.filterPt': 'Company filter',
    'dash.allPt': 'All companies',
    'dash.period': 'Period',
    'dash.from': 'From',
    'dash.to': 'To',
    'dash.filterBar': 'Dashboard filters',
    'dash.quickPeriods': 'Period',
    'dash.applyFilters': 'Apply',
    'dash.refreshData': 'Refresh',
    'dash.applyHint': 'Filters apply live — click to reload data',
    'dash.filtersApplied': 'Data refreshed',
    'dash.activeFilters': 'Active filters',
    'dash.comparePrev': 'Compare vs {from} → {to}',
    'dash.comparePrevShort': 'Compare',
    'dash.filterMore': 'More filters',
    'dash.filterLess': 'Hide extras',
    'dash.ptQuick': 'Company',
    'dash.clearPt': 'All companies',
    'dash.chipCustom': 'Custom',
    'dash.chipMonthShort': 'Month',
    'dash.chip30Short': '30d',
    'dash.chipYearShort': '{year}',
    'dash.monthsAgoShort1': '1 mo ago',
    'dash.monthsAgoShortN': '{n} mo ago',
    'dash.gapTitle': 'Gaps & data completeness',
    'dash.gapHint': 'Summary of statement gaps, audit findings, and tax IDs to complete before close / SPT.',
    'dash.gapScore': 'Score',
    'dash.gapStatement': 'statement gaps',
    'dash.criticalFindings': 'critical findings',
    'dash.reconPending': 'pending reconciliations',
    'dash.metricGaps': 'Statement gaps',
    'dash.metricCritical': 'Critical findings',
    'dash.metricRecon': 'Reconciliation',
    'dash.metricGapsShort': 'gaps',
    'dash.metricCriticalShort': 'critical',
    'dash.metricReconShort': 'recon',
    'dash.npwpEmpty': 'Missing tax ID',
    'dash.completeness': 'Completeness',
    'dash.closeChecklist': 'Close Checklist',
    'dash.shortcuts': 'Shortcuts',
    'dash.quickActions': 'Quick Actions',
    'dash.quickHint': 'Frequent ops menus — jump in without the sidebar.',
    'dash.qaEdit': 'Edit shortcuts',
    'dash.qaDone': 'Done editing',
    'dash.qaAdd': 'Add',
    'dash.qaRemove': 'Remove shortcut',
    'dash.qaReset': 'Reset defaults',
    'dash.qaManageTitle': 'Manage shortcuts',
    'dash.qaManageHint': 'Edit & add favorite menus in the grid below',
    'dash.qaEditingTitle': 'Edit mode on',
    'dash.qaEditingHint': 'Remove items, or tap Add to pin more shortcuts',
    'dash.qaPickTitle': 'Pick shortcuts',
    'dash.qaPickSub': '{n} / {max} selected — tap to add or remove',
    'dash.qaSearch': 'Search menu or page…',
    'dash.qaEmptySearch': 'No matching menus',
    'dash.menus': 'menus',
    'dash.kpiKicker': 'Indicators',
    'dash.kpiTitle': 'Period summary',
    'dash.fxKicker': 'Showcase · Finance charts',
    'dash.fxTitle': 'Cash flow, sales & P&L',
    'dash.fxSub': 'Tap Open to view cash flow, sales & P&L for the filtered period.',
    'dash.fxSubOpen': 'Three visual cards from period data — sample fills empty series.',
    'dash.fxSubShort': 'Tap Open to view period charts.',
    'dash.fxSubOpenShort': 'Three visual cards from the active period.',
    'dash.fxRefresh': 'Refresh',
    'dash.fxOpen': 'Open',
    'dash.fxClose': 'Close',
    'dash.fxApply': 'Apply',
    'dash.fxExpand': 'Expand charts',
    'dash.fxSyncDash': 'Sync from dashboard',
    'dash.fxSearchPt': 'Search company',
    'dash.fxDemo': 'Sample data',
    'dash.fxCashTitle': 'Cash Flow',
    'dash.fxCashIn': 'Cash In',
    'dash.fxCashOut': 'Cash Out',
    'dash.fxCashNet': 'Net Cash',
    'dash.fxOpenCash': 'Open cash-flow report',
    'dash.reconRecentTitle': 'Recent reconciliation',
    'dash.reconLastUpdate': 'Last update',
    'dash.reconRecentEmpty': 'No reconciliation activity yet',
    'dash.reconOpenDesk': 'Open reconciliation desk',
    'dash.reconNew': 'New',
    'dash.reconJustNow': 'just now',
    'dash.reconMinsAgo': '{n} min ago',
    'dash.reconHoursAgo': '{n} hr ago',
    'dash.reconDaysAgo': '{n} days ago',
    'dash.reconPctMatched': 'Matched',
    'dash.reconMatchedToday': 'Today',
    'dash.reconQueue': 'Queue',
    'dash.reconMatchedAmt': 'Matched value',
    'dash.reconSpark7d': '7 days',
    'dash.reconFilterMatch': 'Matches',
    'dash.reconFilterWarn': 'Reject/Undo',
    'dash.reconSearch': 'Search ref / user…',
    'dash.reconNoResults': 'No results',
    'dash.reconAutoLow': 'Auto-match {n} low risk',
    'dash.reconAllUsers': 'All users',
    'dash.reconExportOk': 'Timeline Excel downloaded',
    'dash.reconExportFail': 'Timeline export failed',
    'dash.reconUndoConfirm': 'Undo this match?',
    'dash.reconUndoTapAgain': 'Tap Undo again to confirm',
    'dash.reconUndoOk': 'Match undone',
    'dash.reconUndoFail': 'Undo failed',
    'dash.reconUndoLast': 'Undo last',
    'dash.reconUndoLastHint': 'Undo the last match',
    'dash.reconNotifyOn': 'Reconciliation notifications on',
    'dash.reconNotifyOff': 'Notifications off',
    'dash.reconNotifyOnHint': 'Enable browser notifications',
    'dash.reconNotifyDenied': 'Allow notifications in browser',
    'dash.fxSalesTitle': 'Sales',
    'dash.fxPendapatan': 'Revenue',
    'dash.fxPaid': 'Paid invoices',
    'dash.fxUnpaid': 'Unpaid invoices',
    'dash.fxOpenSales': 'Open invoices',
    'dash.fxPlTitle': 'Profit & Loss',
    'dash.fxRevenue': 'Revenue',
    'dash.fxHpp': 'COGS',
    'dash.fxOpex': 'Expenses',
    'dash.fxLaba': 'Profit',
    'dash.fxOpenPl': 'Open revenue report',
    'dash.fxRange': 'Range {range}',
    'dash.fxCompare': '(vs {range})',
    'dash.insightKicker': 'Analytics · Tax & trends',
    'dash.insightTitle': 'Last 12 months charts',
    'dash.insightTitleYtd': 'Year-to-date charts',
    'dash.insightTitleYtdYear': 'YTD charts · {year}',
    'dash.insightTitleYear': 'Full-year charts · {year}',
    'dash.insightTitle12Year': '12 months ending {year}',
    'dash.insightTitleRange': 'Charts for selected date range',
    'dash.insightSub': 'Revenue, COGS, profit, final income tax & SPT readiness — follows company, year & dates',
    'dash.insightSubLive': '{pt} · {range} · revenue/COGS/P&L/tax & SPT readiness',
    'dash.insightOpen': 'Open',
    'dash.insightClose': 'Close',
    'dash.expandInsight': 'Expand Analytics',
    'dash.insightOmset': 'Revenue',
    'dash.insightHpp': 'COGS',
    'dash.insightOpex': 'Opex',
    'dash.insightGross': 'Gross profit',
    'dash.insightNet': 'Net profit',
    'dash.insightPph': 'Final income tax',
    'dash.insightRadialTitle': 'Finance mix',
    'dash.insightRadialSub': 'Revenue by co. · COGS · Opex · Tax',
    'dash.insightRadialTotal': 'Period revenue',
    'dash.insightCompareTitle': 'Revenue vs COGS',
    'dash.insightCompareSub': 'Monthly comparison · filter window',
    'dash.insightComparePtTitle': 'JGI vs JGT revenue',
    'dash.insightComparePtSub': 'Monthly side-by-side by company',
    'dash.insightPlTitle': 'Monthly P&L',
    'dash.insightPlSub': 'Green profit · orange loss',
    'dash.insightTaxTitle': 'Est. final income tax',
    'dash.insightTaxSub': 'Relative to peak month',
    'dash.insightGaugeTitle': 'SPT / data readiness',
    'dash.insightGaugeSub': 'Completeness score · current year',
    'dash.insightGaugeLabel': 'Score',
    'dash.insightFoot':
      'Final income tax estimated from revenue × company rate (default {rate}% PP 55/2022). Not a substitute for e-SPT — verify before filing.',
    'dash.insightWindow': 'Trend window',
    'dash.insightWin12': '12 months',
    'dash.insightWinYear': 'Year',
    'dash.insightWinRange': 'Range',
    'dash.insightYear': 'Year filter',
    'dash.insightYearHint': 'Click a year to jump back through history',
    'dash.insightSearchLabel': 'Search months',
    'dash.insightApply': 'Apply',
    'dash.insightFollow': 'Follow filters',
    'dash.insightSearchPh': 'Search month / year…',
    'dash.insightMonthsN': '{n} months',
    'dash.insightDataMonths': '{n} with data',
    'dash.insightFiltered': 'filtered {n}',
    'dash.insightNoSearch': 'No months match “{q}”',
    'dash.insightTableTitle': 'Monthly detail',
    'dash.insightAvg': 'Average',
    'dash.insightMargin': 'Margin',
    'dash.insightTrendTitle': 'Revenue & tax trend',
    'dash.insightTrendSub': 'Dual-axis · revenue left · tax right · follows filters',
    'dash.insightColMonth': 'Month',
    'dash.insightColIntensity': 'Intensity',
    'dash.insightColMom': 'MoM',
    'dash.insightPerPage': 'Per page',
    'dash.insightPageAll': 'All',
    'dash.insightPagination': 'Page navigation',
    'dash.insightPagePrev': 'Previous page',
    'dash.insightPageNext': 'Next page',
    'dash.insightPageShowing': 'Showing {from}–{to} of {total}',
    'dash.insightSuggestTitle': 'Smart suggestions',
    'dash.insightSuggestSub': 'Priority actions from trends, tax & data completeness',
    'dash.insightSuggestCount': 'tips',
    'dash.insightHealthTitle': 'Health radar',
    'dash.insightHealthSub': 'Completeness · margin · stability · tax · density',
    'dash.insightHealthScore': 'Health score',
    'dash.insightHealthComplete': 'Complete',
    'dash.insightHealthMargin': 'Margin',
    'dash.insightHealthStable': 'Stability',
    'dash.insightHealthTax': 'Tax',
    'dash.insightHealthDensity': 'Density',
    'dash.insightHealthCompleteShort': 'Done',
    'dash.insightHealthMarginShort': 'Margin',
    'dash.insightHealthStableShort': 'Stable',
    'dash.insightHealthTaxShort': 'Tax',
    'dash.insightHealthDensityShort': 'Dens',
    'dash.insightHeatTitle': 'Revenue heatmap',
    'dash.insightHeatSub': 'Monthly intensity (0–100 vs peak)',
    'dash.insightMixTitle': 'Revenue mix by company',
    'dash.insightMixSub': 'Donut · follows company filter',
    'dash.insightMixEmpty': 'No revenue in this window yet',
    'dash.cashBalance': 'Cash / Bank Balance',
    'dash.cashSubtitle': 'Cash movement for period',
    'dash.bankKicker': 'Treasury',
    'dash.bankTitle': 'Bank balances by company',
    'dash.bankSub': 'Per company: 2 BCA · 2 Mandiri · 2 BNI — balance, last update (date/time) & upload source · {date}',
    'dash.bankSubShort': 'Press Open to view all 6 accounts · {date}',
    'dash.bankExpandHint': 'All companies open · as of {date}',
    'dash.bankAccountsN': '{n} accounts',
    'dash.bankStaleN': '{n} need update',
    'dash.bankExpand': 'Open',
    'dash.bankClose': 'Close',
    'dash.bankDetailHint': '6 accounts · book balance, last update, and upload source',
    'dash.bankUpdateSaldo': 'Update balance',
    'dash.bankUpdateQuick': 'Quick',
    'dash.bankUpdateRekening': 'Update account no.',
    'dash.bankUpdateShort': 'Update acct',
    'dash.bankEmptyAlert': '{n} accounts missing numbers — fill them so smart import stays accurate',
    'dash.bankGoCash': 'Cash position',
    'dash.bankContinueFrom': 'Continue from {date}',
    'dash.bankColAccount': 'Account',
    'dash.bankColNo': 'No.',
    'dash.bankColBalance': 'Balance',
    'dash.bankColUpdate': 'Updated',
    'dash.bankColVia': 'Source',
    'dash.bankTotal': 'Bank total',
    'dash.bankOpen': 'Cash position',
    'dash.bankOpenShort': 'Cash',
    'dash.bankNoEmpty': 'Account number not set',
    'dash.bankViaUnknown': 'No upload yet',
    'bankPop.btn': '6-account history',
    'bankPop.btnShort': 'History 6',
    'bankPop.updateRekening': 'Update account no.',
    'bankPop.emptyAcct': 'Fill account number first',
    'bankPop.kicker': 'Treasury · Bank desk',
    'bankPop.title': 'All accounts · last 12 movements',
    'bankPop.sub':
      'Monitor all 6 accounts per company (2 BCA · 2 Mandiri · 2 BNI): update status, book balance, and recent movements — ready to continue import without duplicates.',
    'bankPop.how':
      'How to use: pick company & account on the left → follow the status tip → open an update link (PDF / quick / manage) → review movements below.',
    'bankPop.refresh': 'Reload account data',
    'bankPop.heroShow': 'Expand header details',
    'bankPop.heroHide': 'Collapse header details',
    'bankPop.filterTitle': 'Movement period filters',
    'bankPop.filterHint': 'Set company & date range, then Apply to open full movements with pagination.',
    'bankPop.accounts': '{n} accounts',
    'bankPop.balance': 'Book balance',
    'bankPop.lastUpdate': 'Last update',
    'bankPop.via': 'Via',
    'bankPop.continueFrom': 'Continue import from',
    'bankPop.continueHint':
      'Start uploading e-statement / bank files from this date to avoid overlapping existing movements. Links below already carry company, bank COA, account no., and continue date.',
    'bankPop.importStmt': 'E-Statement / PDF',
    'bankPop.importQuick': 'Quick debit/credit',
    'bankPop.goCash': 'Cash position',
    'bankPop.guideEmptyTitle': 'Account number is missing',
    'bankPop.guideEmptyBody':
      'Fill the account number on Manage accounts first so e-statement and quick journal can attach to the correct slot.',
    'bankPop.guideStaleTitle': 'Balance update needed',
    'bankPop.guideStaleBody':
      'Latest data is stale. Continue import from {date} via E-Statement/PDF (most accurate) or Quick debit/credit for short entries.',
    'bankPop.guideOkTitle': 'Account is up-to-date',
    'bankPop.guideOkBody':
      'Status looks healthy. Check cash position, run reconciliation, or open the bank report for a professional review.',
    'bankPop.hubTitle': 'Update link hub',
    'bankPop.hubSub': 'All URLs for the active account — ready to open',
    'bankPop.hubMini': '8 work links',
    'bankPop.hubIntro':
      'Each card opens a work page with company / bank / account no. / date already filled. The “Recommended” badge follows the status of the account you are viewing.',
    'bankPop.hubRecommended': 'Recommended',
    'bankPop.hubManage': 'Manage account numbers',
    'bankPop.hubManageDesc':
      'Edit alias, account numbers, and BCA/Mandiri/BNI slots per company. Required when the number is still empty.',
    'bankPop.hubStmt': 'Update balance · E-Statement',
    'bankPop.hubStmtDesc':
      'Upload PDF / smart bank files. Best for catching daily movements up to the continue date.',
    'bankPop.hubQuick': 'Quick debit / credit',
    'bankPop.hubQuickDesc':
      'Enter a few debit-credit lines without PDF. Ideal for small fixes or urgent transactions.',
    'bankPop.hubCash': 'Cash & bank position',
    'bankPop.hubCashDesc':
      'See combined balances, update coverage, and the live account board per company.',
    'bankPop.hubRecon': 'Bank reconciliation',
    'bankPop.hubReconDesc':
      'Match book vs bank movements, clear differences, and keep the recon checklist clean.',
    'bankPop.hubReport': 'Bank report',
    'bankPop.hubReportDesc':
      'Period bank movement summary for management / auditor review.',
    'bankPop.hubLedger': 'General ledger',
    'bankPop.hubLedgerDesc':
      'Open the company ledger for the same period; pick the bank COA for journal detail.',
    'bankPop.hubImport': 'Data import',
    'bankPop.hubImportDesc':
      'Central import for other files (Excel/journals) when the source is not a pure e-statement.',
    'bankPop.lastMoves': 'Last {n} movements (debit/credit)',
    'bankPop.noMoves': 'No movements on this account yet.',
    'bankPop.noMovesHint': 'Try this month, change source filter, or create a quick entry.',
    'bankPop.healthOk': 'All accounts healthy',
    'bankPop.healthWarn': 'Needs attention',
    'bankPop.openLink': 'Open',
    'bankPop.modeLast12': 'Last 12',
    'bankPop.modeBrowse': 'Browse filter',
    'bankPop.mainEmptyTitle': 'No accounts match filters',
    'bankPop.mainEmptyBody': 'Reset status/bank/search filters to see the list again.',
    'bankPop.showAllAccounts': 'Show all accounts',
    'bankPop.full': 'Maximize (fullscreen)',
    'bankPop.exitFull': 'Restore size',
    'bankPop.minimize': 'Minimize',
    'bankPop.windowControls': 'Window controls',
    'bankPop.sizeGroup': 'Popup size',
    'bankPop.sizeS': 'Small (S)',
    'bankPop.sizeM': 'Medium (M)',
    'bankPop.sizeL': 'Large (L)',
    'bankPop.sizeLA': 'Fullscreen (LA)',
    'bankPop.showAmounts': 'Show amounts (auto-hide 60s · E)',
    'bankPop.hideAmounts': 'Hide amounts (E)',
    'bankPop.staleCount': '{n} stale',
    'bankPop.emptyCount': '{n} missing account no.',
    'bankPop.staleShort': '{n} stale',
    'bankPop.emptyShort': '{n} empty',
    'bankPop.quickActions': 'Quick actions',
    'bankPop.continueMini': 'Continue upload',
    'bankPop.healthLine': '{ok} up-to-date · {stale} stale · {empty} empty',
    'bankPop.periodCustom': 'Custom',
    'bankPop.acctSearchPh': 'Search bank, account no., COA, alias…',
    'bankPop.acctFilter': 'Account status filter',
    'bankPop.acctAll': 'All',
    'bankPop.acctStale': 'Stale',
    'bankPop.acctEmpty': 'Empty',
    'bankPop.acctOk': 'Up-to-date',
    'bankPop.acctNoMatch': 'No matching accounts',
    'bankPop.asOf': 'Snapshot · {date}',
    'bankPop.consultantNote': 'Treasury brief · ready for review & continue import',
    'bankPop.from': 'From date',
    'bankPop.to': 'To date',
    'bankPop.search': 'Search',
    'bankPop.searchPh': 'Search description, ref, source…',
    'bankPop.sort': 'Sort',
    'bankPop.sortDateDesc': 'Latest date',
    'bankPop.sortDateAsc': 'Earliest date',
    'bankPop.sortAmtAsc': 'Amount small → large',
    'bankPop.sortAmtDesc': 'Amount large → small',
    'bankPop.sortNameAsc': 'Name A → Z',
    'bankPop.thisMonth': 'View this month',
    'bankPop.thisMonthHint': 'Open current-month movements with pagination (100 / 500 / 1000 / all)',
    'bankPop.backLast12': 'Last 12',
    'bankPop.applyFilter': 'Apply filters',
    'bankPop.movesFound': '{n} matching movements',
    'bankPop.perPage': 'Per page',
    'bankPop.pageAll': 'All',
    'bankPop.pageMeta': 'Page {page} / {pages} · {total} rows',
    'bankPop.revealHint': 'Amounts visible · auto-hide in 60s',
    'bankPop.attentionTitle': 'Needs attention',
    'bankPop.attentionSub': '{n} accounts need action',
    'bankPop.attnEmpty': 'Empty',
    'bankPop.attnStale': 'Stale',
    'bankPop.bankFilter': 'Bank filter',
    'bankPop.bankAll': 'All banks',
    'bankPop.bankOther': 'Other',
    'bankPop.acctSort': 'Sort accounts',
    'bankPop.sortStatus': 'Status first',
    'bankPop.sortBalance': 'Largest balance',
    'bankPop.sortBankName': 'Bank name A–Z',
    'bankPop.copyNo': 'Copy no.',
    'bankPop.copied': 'Copied',
    'bankPop.prevAcct': 'Previous account',
    'bankPop.nextAcct': 'Next account',
    'bankPop.netFlow': 'Net flow (filtered)',
    'bankPop.dcRatio': 'Debit vs credit ratio',
    'bankPop.channelFilter': 'Movement source filter',
    'bankPop.chAll': 'All sources',
    'bankPop.chExcel': 'Excel',
    'bankPop.chEstatement': 'E-Statement',
    'bankPop.chQuick': 'Quick',
    'bankPop.chOther': 'Other',
    'bankPop.shortcuts': 'Keyboard: / search · j/k move · Enter action · 1–4 filter · e amounts',
    'bankPop.sideHint': 'Search, filter by status/bank, then click an account to open detail + update links.',
    'bankPop.pin': 'Pin',
    'bankPop.daysLate': '{n} days',
    'bankPop.deskMode': 'Desk mode',
    'bankPop.modeWork': 'Work',
    'bankPop.modeReview': 'Review',
    'bankPop.checkTitle': 'Daily checklist',
    'bankPop.checkEmpty': 'Fill empty account nos ({n})',
    'bankPop.checkStale': 'Update late accounts ({n})',
    'bankPop.checkReview': 'Mark reviewed today',
    'bankPop.checkRecon': 'Continue reconciliation',
    'bankPop.reviewedOk': 'Today marked as reviewed',
    'bankPop.exportCsv': 'Export movements CSV',
    'bankPop.exportEmpty': 'No movements to export',
    'bankPop.exportOk': 'CSV downloaded ({n} rows)',
    'bankPop.copySummary': 'Copy summary',
    'bankPop.summaryCopied': 'Summary copied',
    'bankPop.batchStale': 'Update {n} late',
    'bankPop.batchNone': 'No late accounts with account numbers',
    'bankPop.batchStart': 'Queued {n} accounts — opening e-statement',
    'bankPop.allHealthyHint': 'All healthy · continue this month import?',
    'dash.omset': 'Revenue',
    'dash.omsetSubtitle': 'Income',
    'dash.grossProfit': 'Gross Profit',
    'dash.grossSubtitle': 'Revenue − COGS',
    'dash.netProfit': 'Net Profit',
    'dash.netSubtitle': 'After operating expenses',
    'dash.performa': 'Performance',
    'dash.omsetQuickTitle': 'Revenue · This Month & Last Month',
    'dash.omsetQuickHint': 'Quick default — 2 months only. Press View to load the full year.',
    'dash.showYtd': 'Show This Year revenue (PKP threshold check)',
    'dash.hideYtd': 'Hide This Year revenue',
    'dash.pkpNear': 'Approaching PKP limit Rp 4.8B',
    'dash.pkpOver': 'Over PKP revenue limit Rp 4.8B',
    'dash.pkpWarn': 'PKP watch (≥70% of limit)',
    'dash.pkpTitle': 'PKP UMKM threshold',
    'dash.pkpOfLimit': '{pct}% of Rp 4.8B',
    'dash.omsetFullHint': '12 months loaded',
    'dash.omsetMonthly': 'Monthly Revenue',
    'dash.viewYear': 'View Year',
    'dash.closeYear': 'Close Year',
    'dash.pickYear': 'Pick year',
    'dash.thisYear': 'This Year',
    'dash.fullYear': 'Full year',
    'dash.detailReport': 'Report detail',
    'dash.month': 'Month',
    'dash.total': 'Total',
    'dash.total2Months': '2-month total',
    'dash.total2MonthsShort': '2-mo total',
    'dash.totalYear': 'Year total',
    'dash.totalYearShort': 'Yr total',
    'dash.noOmset': 'No revenue data yet',
    'dash.thisMonthBadge': 'This Month',
    'dash.seeMore': 'See more…',
    'dash.yearComplete': 'Full year {year}',
    'dash.backTo2Months': 'Back to 2 months',
    'dash.breakdown': 'Breakdown',
    'dash.byCompany': 'By Company',
    'dash.activity': 'Activity',
    'dash.recentJournals': 'Recent Journals',
    'dash.opsKicker': 'Operations',
    'dash.opsTitle': 'Companies & Journals',
    'dash.opsMargin': 'Margin',
    'dash.opsShare': 'Revenue share {pct}%',
    'dash.opsPtEmpty': 'No per-company summary for this period',
    'dash.errSummary': 'Failed to load dashboard summary',
    'dash.opsKasbon': 'Advance',
    'dash.opsPtCount': '{n} companies',
    'dash.opsGotoOmset': 'Revenue report',
    'dash.opsZeroHint':
      'Revenue is Rp 0 for this period. Uploaded e-statements usually appear under This Year — change the period, or upload statements first.',
    'dash.opsFromStmt': 'E-statement',
    'dash.opsOmsetTip': 'Shown: {shown}\nBooks (all sources): {book}\nE-statement: {stmt}',
    'dash.opsHppTip': 'Shown: {shown}\nBooks (all sources): {book}\nE-statement: {stmt}',
    'dash.opsStmtCoverage': 'E-statement {from} → {to} · {n} lines',
    'dash.opsDrillJournals': 'View import journals',
    'dash.opsCtaUpload': 'Upload e-statement',
    'dash.opsHppPct': 'COGS {pct}% of revenue',
    'dash.opsDetail': 'Details',
    'dash.opsCompare': 'Revenue share comparison',
    'dash.opsEntries': 'Entries',
    'dash.srcFilterLabel': 'Journal source filter',
    'dash.srcAll': 'All',
    'dash.srcImport': 'E-statement',
    'dash.srcManual': 'Manual',
    'dash.recentHint': 'Within {period} · showing {limit} · by save time',
    'dash.recentHintShown':
      'Within {period} · showing {shown} entries · limit {limit} · by save time',
    'dash.recentAll': 'all',
    'dash.noJournals': 'No journals in this period.',
    'dash.seeN': 'Show {n}',
    'dash.seeAll': 'Show All',
    'dash.backTo12': 'Back to 12',
    'dash.noMemo': 'No memo',
    'dash.hideFigures': 'Hide figures',
    'dash.showFigures': 'Show figures',
    'dash.pickOmsetYear': 'Pick revenue year',
    'dash.pickOmsetYearHint': 'Pick year (2026, 2025, …)',
    'dash.yearAvailable': 'Available',
    'dash.noOtherYears': 'No other years yet — appear automatically when revenue exists',
    'dash.loadingOmset2m': 'Loading 2-month revenue…',
    'dash.loadingJournals': 'Loading journals…',
    'dash.savedAt': 'Saved',
    'dash.colHpp': 'COGS',
    'dash.colPt': 'Co.',
    'dash.snackSavedRecon': 'Journal {ref} saved → reconciliation queue',
    'dash.snackToJournal': 'View journal',
    'dash.snackToRecon': 'Open reconciliation',
    'dash.vsPrevPeriod': 'Vs previous period',
    'dash.vsPrevShort': 'vs prior',
    'dash.errOmsetYear': 'Failed to load yearly revenue',
    'dash.hasOmsetData': 'Has revenue data',
    'dash.limitNext': '{from} → {to}',
    'dash.limitAll': 'all',

    'period.today': 'Today',
    'period.yesterday': 'Yesterday',
    'period.thisWeek': 'This Week',
    'period.thisMonth': 'This Month',
    'period.thisYear': 'This Year ({year})',
    'period.last7': '7 Days',
    'period.last30': '30 Days',
    'period.last90': '90 Days',
    'period.monthsAgo1': '1 Month Ago ({month} {year})',
    'period.monthsAgoN': '{n} Months Ago ({month} {year})',
    'period.custom': 'Custom (manual)',

    'nav.section.monthDesk': 'Month desk',
    'nav.monthBank': 'Bank desk',
    'nav.monthTax': 'Tax desk',
    'taxDesk.label': 'Tax desk flow',
    'taxDesk.kicker': 'Tax desk',
    'taxDesk.title': 'Linear tax flow',
    'taxDesk.sub': 'Turnover → final tax → withholding → SSP → SPT',
    'taxDesk.stepOmset': 'Turnover',
    'taxDesk.stepOmsetHint': 'Base for final MSME tax',
    'taxDesk.stepFinal': 'Final tax',
    'taxDesk.stepFinalHint': '0.5% MSME per entity',
    'taxDesk.stepWithhold': 'Art. 21/23',
    'taxDesk.stepWithholdHint': 'Withholding & payroll',
    'taxDesk.stepSsp': 'SSP',
    'taxDesk.stepSspHint': 'Payment & e-billing',
    'taxDesk.stepSpt': 'Periodic SPT',
    'taxDesk.stepSptHint': 'Pack & completeness',
    'taxDesk.pph21Link': 'Art. 21 calculator',
    'meja.kicker': 'Month desk',
    'meja.title': '{n} tasks waiting',
    'meja.titleClear': 'Month looks clear — review FS next',
    'meja.sub': 'One grip: bank → HR → assets → tax → FS → lock period.',
    'meja.subShort': 'Bank → HR → assets → tax → FS → lock.',
    'meja.allClear': 'No critical queue',
    'meja.stepBank': 'Bank',
    'meja.stepHr': 'HR',
    'meja.stepFa': 'Assets',
    'meja.stepTax': 'Tax',
    'meja.stepLk': 'FS',
    'meja.stepClose': 'Lock',
    'fcb.kicker': 'Work context',
    'fcb.title': 'Company & period filters',
    'fcb.sub': 'Company & period filter for dashboard, journals, reconciliation, opening balance, and reports.',
    'fcb.dirty': 'Not applied yet',
    'fcb.savedViews': 'Saved',
    'fcb.saveView': 'Save view',
    'fcb.viewName': 'View name',
    'fcb.viewSaved': 'View saved',
    'dash.kpiWhy': 'View source →',
    'inbox.kicker': 'Exception inbox',
    'inbox.title': '{n} items need attention',
    'inbox.todayKicker': 'Today',
    'inbox.todayTitle': '{n} to do today',
    'inbox.todaySub': 'Action queue: journals, reconciliation, tax, attendance, AR/AP, and month-close.',
    'inbox.todaySubShort': 'Action queue: journals, tax, attendance, AR/AP.',
    'inbox.sub': 'Unified queue from journals, reconciliation, advances, data quality, and month-close.',
    'inbox.subShort': 'Unified queue: journals, recon, advances & close.',
    'inbox.why': 'View detail →',
    'inbox.samples': 'Sample refs',
    'inbox.unbal': 'Unbalanced journals',
    'inbox.aging': 'Recon aging 30+',
    'inbox.recon': 'Pending reconciliation',
    'inbox.kasbon': 'Pending advances',
    'inbox.quality': 'Data quality / gaps',
    'inbox.npwp': 'Missing tax ID',
    'inbox.tax': 'Tax deadlines',
    'inbox.attendance': 'Attendance gaps this month',
    'inbox.lock': 'Period locked',
    'inbox.invOverdue': 'Overdue invoices',
    'inbox.invUnpaid': 'Unpaid invoices',
    'inbox.billOverdue': 'Vendor bills overdue',
    'inbox.billUnpaid': 'Vendor bills unpaid',
    'inbox.faDepreciation': 'Asset depreciation not run',
    'inbox.recurringDue': 'Recurring journals due',
    'inbox.journalApproval': 'Journals awaiting approval',
    'inbox.lowStock': 'Low product stock',
    'plb.locked': 'Month {month}/{year} locked',
    'plb.signed': 'Month {month}/{year} signed off',
    'plb.lockedHint': 'Regular journal posts are blocked — unlock in Month Close if needed.',
    'plb.signedHint': 'Active sign-off. Review the checklist before changing this period.',
    'plb.open': 'Open Month Close',

    'qj.kicker': 'Quick transaction',
    'qj.title': 'Quick Debit / Credit',
    'qj.sub': 'Save → enters the reconciliation queue to match statements',
    'qj.company': 'Company',
    'qj.pickPt': 'Select company',
    'qj.date': 'Date',
    'qj.debit': 'Debit Account',
    'qj.credit': 'Credit Account',
    'qj.pickDebit': 'Select debit account',
    'qj.pickCredit': 'Select credit account',
    'qj.accountSearch': 'Type account code or name…',
    'qj.accountNoMatch': 'No matching accounts',
    'ss.searchPh': 'Search code, name, number…',
    'ss.noMatch': 'No matches',
    'bsp.searchPh': 'Search bank, code, account no…',
    'qj.amount': 'Amount',
    'qj.amountDebit': 'Debit (number)',
    'qj.amountCredit': 'Credit (number)',
    'qj.addToTable': 'Add to table',
    'qj.singleSub': 'Enter debit/credit numbers → Add to the table below → save the queue to reconciliation',
    'qj.singleQueueTitle': 'Single-entry queue',
    'qj.singleQueueSub': '{n} rows ready to save',
    'qj.singleQueueEmpty': 'No rows yet — fill the form, then click Add to table.',
    'qj.clearQueue': 'Clear',
    'qj.saveQueue': 'Save queue ({n})',
    'qj.errNoSingleQueue': 'No selected rows in the queue.',
    'qj.memo': 'Memo / notes',
    'qj.memoPh': 'Short note…',
    'qj.note': 'Note',
    'qj.save': 'Save Journal',
    'qj.refTemp': 'temporary · locked unique on save',
    'qj.refSaved': 'saved',
    'qj.refLoading': 'loading…',
    'qj.shortcutHint': 'Ctrl+Enter queue · Esc reset · Ctrl+Z undo',
    'qj.undoLast': 'Undo',
    'qj.undoLastHint': 'Undo last queued row (Ctrl+Z)',
    'qj.copyToForm': 'Copy to form',
    'qj.copyToFormHint': 'Load this row into the Quick Entry form to edit',
    'qj.formatHint': 'Format: 300,000.81 · ID paste 300.000,81 also OK · fill either Debit or Credit',
    'qj.staging': 'Staging',
    'qj.errIncomplete': 'Fill entity, description, cash/bank, contra account, and a Debit or Credit amount',
    'qj.errSave': 'Failed to save journal',
    'qj.savedRef': 'Saved · Ref ID',
    'qj.track': 'Track',
    'qj.openRecon': 'Open Reconciliation',
    'qj.refId': 'Ref ID',
    'qj.pageKicker': 'Transactions',
    'qj.pageHint': 'Amounts auto-detect old (dot) & new (comma) formats — e.g. 300.000,81 → 300,000.81',
    'qj.linkJournals': 'Journals',
    'qj.openReports': 'Open reports',
    'qj.openBs': 'Balance sheet',
    'qj.openLk': 'Financial statements',
    'qj.mutasiTitle': 'Latest account movements',
    'qj.mutasiSub': 'From e-statements / journals already in the books. Click a row to fill quick journal.',
    'qj.mutasiEmpty': 'No movements for this company yet. Upload an e-statement or pick an account first.',
    'qj.mutasiUse': 'Fill journal',
    'qj.mutasiOpen': 'Track',
    'qj.stmtPostedTitle': 'Journals received from uploaded statements',
    'qj.stmtPostedSub': 'E-statement lines already posted. Continue multi-row entry for anything still missing.',
    'qj.stmtPostedEmpty': 'No e-statement journals yet. Upload on Smart upload, then ACC.',
    'qj.stmtPostedRefresh': 'Refresh',
    'qj.savedNext': 'Continue to reports',
    'qj.mode.label': 'Entry mode',
    'qj.mode.upload': 'Smart upload',
    'qj.mode.manual': 'Multi-row',
    'qj.mode.single': 'Single entry',
    'qj.health.ok': 'Ready',
    'qj.health.warn': 'Needs attention',
    'qj.health.bankOk': 'Bank ready',
    'qj.health.bankNeed': 'Pick company + bank',
    'qj.health.selected': 'Selected {n}',
    'qj.health.invalid': 'Invalid {n}',
    'qj.health.needCheck': 'Needs review {n}',
    'qj.health.volume': 'Dr {d} · Cr {c}',
    'qj.health.rows': '{n} rows',
    'qj.sec.identity': 'Identity',
    'qj.sec.amount': 'Amount',
    'qj.sec.bank': 'Cash / Bank',
    'qj.sec.contra': 'Contra account',
    'qj.sec.meta': 'Meta',
    'qj.empty.uploadTitle': 'No parsed rows yet',
    'qj.empty.uploadSub': 'Pick company & account, upload proof, then Parse.',
    'qj.showDemo': 'Show example',
    'qj.hideDemo': 'Hide example',
    'qj.snackSaved': 'Saved {ref} · {n} lines',

    'month.0': 'January',
    'month.1': 'February',
    'month.2': 'March',
    'month.3': 'April',
    'month.4': 'May',
    'month.5': 'June',
    'month.6': 'July',
    'month.7': 'August',
    'month.8': 'September',
    'month.9': 'October',
    'month.10': 'November',
    'month.11': 'December',
    'monthShort.0': 'Jan',
    'monthShort.1': 'Feb',
    'monthShort.2': 'Mar',
    'monthShort.3': 'Apr',
    'monthShort.4': 'May',
    'monthShort.5': 'Jun',
    'monthShort.6': 'Jul',
    'monthShort.7': 'Aug',
    'monthShort.8': 'Sep',
    'monthShort.9': 'Oct',
    'monthShort.10': 'Nov',
    'monthShort.11': 'Dec',

    'tasya.name': 'Tasya',
    'tasya.fabHover':
      'Hi! My name is Tasya 🎀\nReady to teach menus + quick checks (after login)!',
    'tasya.status': 'Online · Ready to help',
    'tasya.welcome':
      'Hi! My name is Tasya 🎀 Your accounting buddy for JasaPembayaran.\n\nI only work for the signed-in account.\n• Teach every menu step-by-step\n• Quick checks (journal/COA/PT counts)\n• Explain one Ref you name\n\nI never change system data, and I never share details with outsiders.',
    'tasya.placeholder': 'Hi Tasya, I’d like to ask…',
    'tasya.send': 'Send',
    'tasya.open': 'Say hi to Tasya',
    'tasya.close': 'Close',
    'tasya.clear': 'Clear chat',
    'tasya.hint':
      'Enter to send · Q&A only · Data belongs to your login · Tasya never changes the system',
    'tasya.error': 'Tasya couldn’t reply. Please try again shortly.',
    'tasya.needLogin': 'Tasya is only available after login. Please sign in first.',
    'tasya.emptyReply': 'No reply yet. Try rephrasing your question.',
    'tasya.thinking': 'Tasya is thinking…',
    'tasya.quickTitle': 'Suggested questions',
    'tasya.q1': 'How do I import e-statements step by step?',
    'tasya.q2': 'What’s the difference: JGI vs JGT here?',
    'tasya.q3': 'How to calculate & post final income tax 0.5%?',
    'tasya.q4': 'How to use Quick Debit/Credit on the dashboard?',
    'tasya.q5': 'Reconciliation flow after saving a journal?',
    'tasya.q6': 'Where do I find omset & P&L reports?',
    'tasya.page.dash': 'You’re on Dashboard — KPIs, smart upload, quick journal',
    'tasya.page.stmt': 'You’re on Smart E-Statement — upload & AI mapping',
    'tasya.page.recon': 'You’re on Reconciliation — match statements to journals',
    'tasya.page.tax': 'You’re in Tax Center — final income tax & SPT',
    'tasya.page.master': 'You’re in chart of accounts / bank accounts',
    'tasya.page.reports': 'You’re in Reports — filter by company & period',
    'tasya.page.journals': 'You’re in Journal — General / Adjusting / Correction / Closing',
    'tasya.page.generic': 'Active page: {path}',

    'tsy.kicker': 'Control',
    'tsy.title': 'Tasya Livechat',
    'tsy.sub': 'Configure welcome text, FAB bubble, status, placeholder, and suggested questions. Changes apply to every signed-in user.',
    'tsy.statusCustom': 'Custom text active',
    'tsy.statusDefault': 'Using system default',
    'tsy.unsaved': 'Unsaved',
    'tsy.unsavedBar': 'You have unsaved changes',
    'tsy.discard': 'Discard',
    'tsy.updated': 'Updated {at} · {by}',
    'tsy.reset': 'Restore defaults',
    'tsy.resetShort': 'Default',
    'tsy.save': 'Save text',
    'tsy.saveShort': 'Save',
    'tsy.loading': 'Loading Tasya settings…',
    'tsy.loadFail': 'Failed to load Tasya settings',
    'tsy.saveFail': 'Failed to save',
    'tsy.saved': 'Tasya text saved',
    'tsy.resetOk': 'Restored default text',
    'tsy.needWelcome': 'Fill welcome text in ID and EN',
    'tsy.needFab': 'Fill FAB bubble text in ID and EN',
    'tsy.needStatus': 'Fill online status in ID and EN',
    'tsy.needPlaceholder': 'Fill placeholder in ID and EN',
    'tsy.needQuickTitle': 'Fill suggestions title in ID and EN',
    'tsy.needSuggestion': 'Fill suggestion #{n} in ID and EN',
    'tsy.tooLongWelcome': 'Welcome text is too long',
    'tsy.tooLongFab': 'FAB text is too long',
    'tsy.welcomeTitle': 'Welcome message',
    'tsy.welcomeHint': 'Shown as the first message when Tasya chat opens.',
    'tsy.welcomePhId': 'Write Tasya’s greeting & capability summary…',
    'tsy.welcomePhEn': 'Write Tasya’s greeting & capability summary…',
    'tsy.fabTitle': 'Floating button bubble',
    'tsy.fabHint': 'Short text beside the Tasya avatar in the corner.',
    'tsy.chromeTitle': 'Status & input',
    'tsy.chromeHint': 'Header status line and composer placeholder.',
    'tsy.statusLabel': 'Online status',
    'tsy.placeholderLabel': 'Input placeholder',
    'tsy.suggestTitle': 'Suggested questions',
    'tsy.suggestHint': 'Quick chips under the welcome message (6 items).',
    'tsy.quickTitleLabel': 'Suggestions block title',
    'tsy.suggestPh': 'Suggestion #{n}',
    'tsy.previewTitle': 'Live preview',
    'tsy.previewHint': 'Follows the active UI language (not the edit tab).',
    'tsy.previewPanel': 'Chat',
    'tsy.previewFab': 'FAB',
    'tsy.previewNow': 'now',
    'tsy.editLang': 'Language being edited',
    'tsy.tipsTitle': 'Setup tips',
    'tsy.tip1': 'Switch ID/EN with the language tabs above the form.',
    'tsy.tip2': 'Keep the FAB short (1–2 lines) so it doesn’t cover content.',
    'tsy.tip3': 'After Save, Tasya chat picks up the new copy without a full refresh.',
    'tsy.langId': 'Indonesian',
    'tsy.langEn': 'English',
} as const;

export const messages = {
  id: { ...messagesId, ...pageMessages.id },
  en: { ...messagesEn, ...pageMessages.en },
} as const;

export type MessageKey = keyof typeof messages.id;
